const translations = {
  language: "Idioma",
  login: {
    welcome: "Bienvenido",
    ssoLogin: "Accede con el correo de tu cuenta",
    detailsGeneric: "Detalles",
    customers: "Usuarios finales",
    sendEmail: "Enviar correo electrónico",
    otpLogin: "Iniciar sesión con correo electrónico",
    login: "Iniciar sesión",
    changeEmail: "Usar dirección de correo diferente",
    or: "O",
    dontHaveAccount: "No tienes una cuenta?",
    requestAccess: 'Solicitar acceso',
    accessRequestTitle: 'Solicitar acceso',
  },
  domains: {
    customerAdminDeletionConfirm: "¿Desea eliminar este usuario final? La operación no se puede deshacer",
    customerAdminDeletionSuccess: "Usuario final eliminado con éxito",
    luckeyDomainsTitle: "Dominios",
    domainName: "Nombre de dominio",
    domainDetails: "Detalles del dominio",
    domainConfigModifySuccess: "Configuración del dominio modificada y actualizada",
    domainConfigTitle: "Configuraciones - Alternancia de funciones",
    domainConfigDescription: "Configuración del dominio en formato JSON. Utilícela para habilitar/deshabilitar funciones del dominio",
    domainConfigGuide: "Guía de configuraciones de dominio",
    noUsersFoundTitle: "Lista de usuarios vacía",
    domainUsersTitle: "Administradores del dominio",
    domainUsersDescription: "Personifica a uno de los administradores de usuarios para operaciones de mantenimiento en el dominio",
    domainUsersWarning: "ATENCIÓN: Al personificar usuarios, puedes realizar cambios en el sistema, incluso irreversibles. Usa la máxima precaución",
    noUsersFoundDescription: "No se ha encontrado ningún usuario en este dominio",
    noDomainsFoundTitle: "No se encontraron dominios",
    noDomainFoundDescription: "La lista de dominios está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo",
    impersonateSuccess: "Impersonación de usuario exitosa",
    domainSubsriptionTitle: "Suscripción del dominio",
    domainSubsriptionDescription: "Lista de suscripción del dominio: bloqueos, usuarios y vencimiento del dominio",
    expiration: "Vencimiento",
    totalNumber: "Número total",
    used: "Elementos usados",
    tooMuchElements: "ADVERTENCIA: EL DOMINIO HA SUPERADO EL LÍMITE DE ELEMENTOS TOTALES",
    newDomain: "Nuevo dominio",
    externalReference: "Referencia externa",
    externalReferenceDetails: "Por ejemplo \"date-purchaseId\"",
    productDescription: "El producto representa la licencia que se activará para el nuevo dominio",
    productTitle: "Tipo de suscripción",
    extendDomain: "Extender la suscripción del dominio",
    extendDomainDescription: "Extiende tu dominio con un complemento o clave de producto",
    domainInstallersTitle: "Instaladores del dominio",
    domainInstallersDescription: "Lista de usuarios instaladores en los dominios seleccionados",
    domainDeletionTitle: "Eliminar dominio",
    domainDeletionDescription: "Enviar una solicitud para eliminar este dominio",
    sendDeletionRequest: "Enviar",
    domainDeletionConfirm: "¿Desea enviar una solicitud para eliminar este dominio?",
    domainDeletionSuccess: "Solicitud enviada con éxito",
    customerDeletionTitle: "Eliminar usuario final",
    customerDeletionConfirm: "¿Desea enviar una solicitud para eliminar este usuario final?",
    customerDeletionSuccess: "Solicitud enviada con éxito",
    walletDeletionTitle: "Eliminar billetera",
    walletDeletionConfirm: "¿Desea enviar una solicitud para eliminar esta billetera?",
    walletDeletionSuccess: "Solicitud enviada con éxito",
    verifyServiceStatus: "Estado del servicio",
    impersonateUser: "Personificar usuario",
    impersonate: "Personificar",
    impersonateReadOnly: "Personificar en modo solo lectura",
    domainAdditionalInfo: "Información adicional del dominio",
    domainAdditionalInfoDescription: "Proporcione información adicional del dominio aquí",
    additionalInfoSavedSuccessfully: "Notas adicionales guardadas con éxito",
    EASY: "Solo Argo Locks",
    SMART: "Argo Locks + Gateway",
    ENTERPRISE: "V364 + Argo Locks",
    STANDARD: "Solo V364 Locks",
    numberOfArgoLocks: "Argo",
    numberOfVegaLocks: "V364",
    numberOfGatewaysLocks: "Gateways",
    numberOfUsers: "Usuarios",
    numberOfLocks: "Cerraduras inteligentes",
    federatedDomain: "Dominio vinculado a: {{domain}}",
    federatedMasterDomain: "Dominio principal de un grupo",
    domainFederatedLicense: "Suscripción de dominio federado: esta suscripción es unificada para todos los dominios pertenecientes al dominio principal {{domain}}",
    federatedDomains: "Grupo de dominios",
    federatedDomainsDescription: "El dominio pertenece a un grupo",
    installationMode: "Modo de instalación",
    domainStandard: "Dominio legado",
    domainWithCloudCredits: "Dominio con créditos en la nube",
    domainIrisRequired: "Se requiere 1RIS",
    domainIrisEnabled: "1RIS habilitado",
    domainIrisEnable: "Habilitar 1RIS",
    domainIrisEnableConfirm: "¿Desea configurar 1RIS como HABILITADO en este dominio?",
    editPlantDetails: "Editar detalles de la instalación",
    editPlantDetailsSuccess: "Detalles de la instalación actualizados con éxito",
    zenDeskId: "ZenDesk Id",
    lockbaseId: "Lockbase Id",
    license1ris: "Licencia 1RIS",
    domainsWithCloudCredits: "Dominios con créditos en la nube",
    domainsLegacy: "Dominios legados",
    domainSecretsTitle: "Secretos del dominio",
    domainSecretsDescription: "Credenciales guardadas en este dominio, mostradas descifradas",
    domainSecretsEmpty: "No hay secretos guardados para este dominio",
    domainSecretsError: "No se pudieron cargar los secretos del dominio",
    domainSecretsYes: "Sí",
    domainSecretsNo: "No",
    domainSecretsCopied: "Copiado",
    domainSecretsKey: "Clave",
    domainSecretsValue: "Valor",
    domainSecretsAdd: "Añadir clave",
    domainSecretsEdit: "Editar",
    domainSecretsFieldType: "Tipo de campo",
    domainSecretsFieldTypeText: "Texto",
    domainSecretsFieldTypePassword: "Contraseña",
    domainSecretsFieldTypeUrl: "URL",
    domainSecretsFieldTypeBoolean: "Sí / No",
    domainSecretsShowPassword: "Mostrar valor",
    domainSecretsHidePassword: "Ocultar valor",
    domainSecretsDelete: "Eliminar campo",
    domainSecretsDeleteConfirm: "¿Eliminar el campo \"{{key}}\"?",
    domainSecretsSaveError: "No se pudieron guardar los secretos del dominio",
    domainAppConfigurationTitle: 'Comprobación de login personalizada',
    domainAppConfigurationDescription: 'Endpoints HTTPS para verificar el email del usuario al iniciar sesión',
    domainAppConfigurationUrlsLabel: 'URLs de comprobación',
    domainAppConfigurationUrlsHint: 'Una URL HTTPS por línea. Use {placeholder} para un segmento de ruta. Deje vacío para borrar la configuración.',
    domainAppConfigurationFieldsLabel: 'Campos de email en la respuesta',
    domainAppConfigurationFieldsHint: 'Un nombre de campo JSON por línea (p. ej. email). Obligatorio si hay URLs configuradas.',
    domainAppConfigurationLoadError: 'No se pudo cargar la configuración de la app',
    domainAppConfigurationSaveError: 'No se pudo guardar la configuración de la app',
    domainAppConfigurationInvalidUrl: 'Una o más URLs no son válidas (HTTPS obligatorio, sin IP ni localhost)',
    domainAppConfigurationFieldsRequired: 'Se requiere al menos un campo de email cuando hay URLs de comprobación configuradas',
  },
  credits: {
    pricelistImport: 'Importar lista de precios',
    pricelistImportTitle: 'Importar lista de precios',
    pricelistChooseFile: 'Elegir archivo (.xlsx, .xls, .csv)',
    pricelistChooseAnotherFile: 'Elegir otro archivo',
    pricelistDownloadTemplate: 'Descargar plantilla',
    pricelistSheet: 'Hoja',
    pricelistCompany: 'Empresa',
    pricelistSelectCompany: 'Selecciona la empresa cuyas filas quieres importar',
    pricelistError: 'Error al importar la lista de precios: {{message}}',
    pricelistStatus_NEW: 'Nuevas',
    pricelistStatus_CHANGED: 'Modificadas',
    pricelistStatus_READONLY_CHANGED: 'Diferencias no editables',
    pricelistStatus_UNCHANGED: 'Sin cambios',
    pricelistStatus_ERROR: 'Errores',
    pricelistStatus_SKIPPED: 'Omitidas',
    pricelistFilterAll: 'Todas',
    pricelistColumnRow: 'Fila',
    pricelistColumnMainTier: 'Main tier',
    pricelistColumnStatus: 'Estado',
    pricelistColumnDetails: 'Detalles',
    pricelistOnlyInBackend: '{{count}} suscripciones existentes no están en el archivo y no se tocarán',
    pricelistParseErrors: 'Filas con errores ({{count}}), se omitirán',
    pricelistRowError: 'Fila {{row}} ({{sku}}): {{message}}',
    pricelistShowingFirst: 'Mostrando las primeras {{count}} de {{total}} filas',
    pricelistNoRows: 'No hay filas para este filtro',
    pricelistApply: 'Aplicar {{count}} cambios',
    pricelistApplyTitle: 'Aplicar lista de precios',
    pricelistApplyConfirm: 'Se crearán {{created}} y se actualizarán {{updated}} suscripciones de este marketplace. ¿Quieres continuar?',
    pricelistApplyConfirmWithErrors: 'Se crearán {{created}} y se actualizarán {{updated}} suscripciones de este marketplace. Se omitirán {{errors}} filas con errores. ¿Quieres continuar?',
    pricelistApplying: 'Aplicando cambios: {{done}} / {{total}}',
    pricelistResultSummary: 'Creadas: {{created}} - Actualizadas: {{updated}} - Fallidas: {{failed}}',
    pricelistFailedItem: '{{sku}} (main tier: {{tier}}): {{message}}',
    customerPlantLockbaseId: 'ID Lockbase',
    customerPlantName: 'Nombre del dominio',
    defaultMarketplace: 'Predeterminado',
    setMarketplaceAsDefault: 'Establecer como predeterminado',
    marketplaceSetAsDefaultConfirm: '¿Desea establecer este mercado como predeterminado?',
    marketplaceSetAsDefaultError: 'Error al establecer el mercado como predeterminado',
    notificationStartDate: 'Fecha de inicio de notificación',
    notificationAssociatedServices: 'Servicios asociados (opcional)',
    notificationAssociatedServicesHelp: 'Seleccione uno o más servicios para asociar con esta notificación. Deje este campo vacío para notificaciones generales de contrato.',
    selectContractServices: 'Seleccionar servicios',
    notificationPeriodicMode: 'Modo de programación',
    notificationPeriodicModeStartDate: 'Iniciar desde una fecha específica',
    notificationPeriodicModeDayOfMonth: 'Iniciar desde un día específico del mes',
    contractServicePrice: 'Precio',
    contractServiceOriginalPrice: 'Precio original',
    contractServiceCurrency: 'Moneda',
    notificationRuleFormTitle: 'Regla de Notificación de Contrato',
    notificationRuleType: 'Tipo de notificación',
    notificationRuleType_ONCE: 'Una vez',
    notificationRuleType_PERIODIC: 'Recurrente',
    notificationSpecificDate: 'Fecha de notificación',
    notificationIntervalMonths: 'Repetir cada',
    notificationDayOfMonth: 'Día del mes',
    notificationEmails: 'Direcciones de correo electrónico',
    notificationEmailsHelp: 'Ingrese las direcciones de correo electrónico separadas por comas',
    notificationAssociatedService: 'Servicio asociado (opcional)',
    notificationEnabled: 'Habilitado',
    nextRun: 'Próxima ejecución',
    schedule: 'Programación',
    notificationIntervalMonths_1: 'Cada mes',
    notificationIntervalMonths_2: 'Cada 2 meses',
    notificationIntervalMonths_3: 'Cada 3 meses',
    notificationIntervalMonths_4: 'Cada 4 meses',
    notificationIntervalMonths_6: 'Cada 6 meses',
    notificationIntervalMonths_12: 'Cada año',
    newNotificationRule: 'Nueva notificación',
    editNotificationRule: 'Editar notificación',
    deleteNotificationRule: 'Eliminar notificación',
    deleteNotificationRuleConfirm: '¿Desea eliminar esta notificación?',
    notificationRuleCreationConfirm: '¿Desea crear la nueva notificación?',
    notificationRuleEditConfirm: 'Está a punto de editar la notificación. ¿Está seguro de que desea continuar?',
    noNotificationRulesFound: 'No se encontraron notificaciones',
    noNotificationRulesDescription: 'La lista de notificaciones está vacía. Crea una nueva notificación para comenzar.',
    selectContractService: 'Seleccionar un servicio',
    noContractServicesFound: 'No se encontraron servicios para este contrato',
    noServiceSelected: 'Ningún servicio seleccionado (notificación general)',
    generalContractNotification: 'Notificación general del contrato',
    serviceSpecificNotification: 'Notificación específica del servicio',
    andMoreEmails: 'y {{count}} correos más',
    dayOfMonthValidationError: 'El día debe estar entre 1 y 28',
    dayOfMonthHelp: 'Ingrese un día entre 1 y 28',
    createCustomerContractNotificationRuleError: 'Error al crear la notificación',
    editCustomerContractNotificationRuleError: 'Error al editar la notificación',
    deleteCustomerContractNotificationRuleError: 'Error al eliminar la notificación',
    enterEmail: 'Ingrese dirección de correo electrónico',
    domainsPeriodic: 'Dominios periódicos',
    andMorePlants: 'y {{count}} más',
    andMoreServices: 'y {{count}} más',
    customerContractSearch: 'Buscar contrato',
    domainPeriodic: 'Dominio periódico',
    customerPlantHostname: 'URL del dominio',
    customerPlantSolution: 'Solución',
    customerPlantManagement: 'Tipo de hosting',
    customerPlantModality: 'Modalidad',
    customerPlantSubSegment: 'Subsegmento',
    customerPlantZendesk: 'ID de Zendesk',
    customerPlantLoginData: 'Datos de acceso',
    customerPlantLicense1ris: 'Número de serie de la licencia',
    openZendesk: 'Abrir Zendesk',
    totalInvoicedWithExplanation: 'Total facturado (Precio neto x Cantidad)',
    netPrice: 'Precio neto',
    quantity: 'Cantidad',
    totalInvoiced: 'Total facturado',
    customerPlants: 'Impiantes',
    customerPlantPlatform: 'Platform',
    customerPlantPlatformIris: '1RIS',
    customerPlantPlatformIrisArgo: '1RIS + ARGO',
    customerPlantPlatformArgo: 'ARGO',
    customerPlantSolutionLsa: 'LSA',
    customerPlantSolutionV364: 'V364',
    customerPlantSolutionV364Classic: 'V364 Classic',
    customerPlantSolutionLuckey: 'Luckey',
    customerPlantSolutionArgo: 'Argo',
    customerPlantSolutionFlex: 'Flex',
    customerPlantSolutionLwc: 'LWC',
    customerPlantSolutionAtg: 'ATG',
    customerPlantSolutionVar: 'VAR',
    customerPlantType: 'Plant type',
    customerPlantTypePreprodPilot: 'Preprod - Pilot',
    customerPlantTypePreprodProduction: 'Preprod - Production',
    customerPlantTypeProdPilot: 'Prod - Pilot',
    customerPlantTypeProdProduction: 'Prod - Production',
    customerPlantTypeProdDisabled: 'Prod - Disabled',
    customerPlantTypeDemo: 'Demo',
    customerPlantTypeDead: 'Dead',
    customerPlantSolutionMechanic: 'Mechanic',
    customerPlantSolutionOther: 'Other',
    customerPlantManagementOnPremiseClassic: 'On Premise::Classic',
    customerPlantManagementOnPremiseVmNative: 'On Premise::VM Native',
    customerPlantManagementOnPremiseVmDockerBased: 'On Premise::VM Docker Based',
    customerPlantManagementOnPremiseContainer: 'On Premise::Container',
    customerPlantManagementOnPremiseOther: 'On Premise::Other',
    customerPlantManagementSaasAzure: 'SaaS::Azure',
    customerPlantManagementSaasAws: 'SaaS:AWS',
    customerPlantManagementOther: 'Other',
    customerPlantModalityPeriodic: 'Periódico',
    customerPlantModalityCredits: 'Créditos',
    createCustomerDomainError: 'No se puede crear o editar el dominio. Verifique los datos ingresados e intente nuevamente',
    noCustomerDomainFindTitle: 'No se encontraron dominios',
    noCustomerDomainFindDescription: 'La lista de dominios está vacía. Si ha establecido un filtro de búsqueda, intente restablecerlo y vuelva a intentarlo',
    editCustomerDomain: 'Editar dominio',
    editCustomerDomainConfirm: 'Está a punto de editar los datos del dominio. ¿Está seguro de que desea continuar?',
    newCustomerDomain: 'Nuevo dominio',
    customerDomainCreationConfirm: '¿Desea crear el nuevo dominio?',
    deleteCustomerDomainError: 'No se puede eliminar el dominio. Por favor, inténtelo de nuevo',
    deleteCustomerDomainConfirm: '¿Desea eliminar el dominio?',
    customerContractActivationDate: 'Fecha de activación',
    customerContractDeactivationDate: 'Fecha de desactivación',
    customerContractDetails: 'Detalles del contrato',
    contractServices: 'Servicios',
    contractService: 'Servicio',
    contractDocuments: 'Documentos',
    contractNotifications: 'Notificaciones',
    deleteCustomerContract: 'Eliminar contrato',
    deleteCustomerContractConfirm: '¿Desea eliminar el contrato?',
    deleteCustomerContractError: 'No se puede eliminar el contrato. Por favor, inténtelo de nuevo',
    associateNewPlantToContract: 'Asociar nuevo dominio',
    addCustomerPlantMessage: 'Seleccione el dominio para agregar a este contrato',
    removeCustomerPlantFromContract: 'Eliminar',
    removeCustomerPlantFromContractConfirm: '¿Desea eliminar el dominio del contrato?',
    addCustomerPlantToContractError: 'No se puede agregar el dominio al contrato. Por favor, inténtelo de nuevo',
    removeCustomerPlantFromContractError: 'No se puede eliminar el dominio del contrato. Por favor, inténtelo de nuevo',
    customerContractStatus_ACTIVE: 'Activo',
    customerContractStatus_NOT_ACTIVE: 'Inactivo',
    customerContractStatus_CANCELLED: 'Cancelado',
    downloadDocument: 'Descargar',
    associateNewDocumentToContract: 'Agregar documento',
    addDocument: 'Agregar documento',
    addDocumentMessage: 'Seleccione el documento para agregar a este contrato',
    documentName: 'Nombre del archivo',
    addDocumentToContractError: 'No se puede agregar el documento al contrato. Por favor, inténtelo de nuevo',
    deleteContractDocumentConfirm: '¿Desea eliminar este documento?',
    deleteContractDocumentError: 'No se puede eliminar el documento. Por favor, inténtelo de nuevo',
    noCustomerContractDocumentFindTitle: 'No se encontraron documentos',
    noCustomerContractDocumentFindDescription: 'La lista de documentos está vacía. Si ha establecido un filtro de búsqueda, intente restablecerlo y vuelva a intentarlo',
    noCustomerContractServiceFindTitle: 'No se encontraron servicios',
    noCustomerContractServiceFindDescription: 'La lista de servicios está vacía. Si ha establecido un filtro de búsqueda, intente restablecerlo y vuelva a intentarlo',
    editCustomerContractService: 'Editar servicio',
    editCustomerContractServiceConfirm: 'Está a punto de editar los datos del servicio. ¿Está seguro de que desea continuar?',
    createCustomerContractServiceError: 'No se puede crear el servicio. Verifique los datos ingresados e intente nuevamente',
    deleteCustomerContractServiceError: 'No se puede eliminar el servicio. Por favor, inténtelo de nuevo',
    deleteCustomerContractServiceConfirm: '¿Desea eliminar el servicio?',
    newCustomerContractService: 'Nuevo servicio',
    customerContractServiceCreationConfirm: '¿Desea crear el nuevo servicio?',
    customerContractServiceFormTitle: 'Servicio de Contrato de Cliente',
    duplicateCustomerContractServiceFormTitle: 'Duplicar Servicio de Contrato de Cliente',
    customerDomainFormTitle: 'Sistema',
    manageDomainFromWallet: 'Puede gestionar este dominio desde su página de wallet: {{walletName}}',
    selectService: 'Seleccionar servicio',
    noServicesFound: 'No se encontraron servicios',
    serviceSubject: 'Asunto',
    serviceGroupFamily: 'Familia de grupo',
    serviceType: 'Tipo',
    searchContractService: 'Buscar servicio por código, asunto, familia de grupo...',
    contractServiceCode: 'Código',
    customerServiceSelloutPONumber: 'Número de PO de venta',
    customerServiceSfdcId: 'ID de SFDC',
    customerContractServiceNotes: 'Notas',
    customerContractServiceStatus: 'Estado',
    customerContractServiceStatus_WAITING_FOR_ACTIVATION: 'Esperando activación',
    customerContractServiceStatus_ACTIVE: 'Activo',
    customerContractServiceStatus_PAUSED: 'Pausado',
    customerContractServiceStatus_CANCELLED: 'Cancelado',
    customerContractServiceStatus_INACTIVE: 'Inactivo',
    customerContractServiceStatus_WAITING_TO_BE_DONE: 'Esperando realización',
    customerContractServiceStatus_WORK_IN_PROGRESS: 'En progreso',
    customerContractServiceStatus_DONE: 'Completado',
    sfdcIdAndSelloutPo: 'ID de SFDC | PO de venta',
    groupFamilySubjectCode: 'Servicio',
    activationDeactivationStatus: 'Estado',
    noPlantsAssociated: 'No hay dominios asociados',
    noServicesAssociated: 'No hay servicios asociados',
    loadingServices: 'Cargando servicios...',
    chooseFile: 'Elegir archivo',
    exportCustomerContractsCSV: 'Exportar CSV',
    exportCustomerContractsXLSX: 'Exportar Excel',
    exportCustomerContractsError: 'Error al exportar CSV',
    exportCustomerContractServicesCSV: 'Exportar CSV',
    exportCustomerContractServicesError: 'Error al exportar CSV',
    customerAndContract: 'Cliente | Contrato',
    customerContract: 'Contrato',
    customer: 'Cliente',
    customerContractServiceSearch: 'Buscar servicio',
    customerContractName: 'Nombre del contrato',
    customerContractStatus: 'Estado del contrato',
    customerContractSigningDate: 'Fecha de firma',
    customerContractExpirationDate: 'Fecha de expiración',
    marketplaces: "Mercados",
    searchMarketplace: "Buscar en el mercado...",
    marketplaceName: "Nombre del mercado",
    luckeyMarketplaceTitle: "Mercados Luckey",
    noMarketplaceFoundTitle: "No se encontró ningún mercado",
    noMarketplaceFoundDescription: "La lista de mercados está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo",
    newMarketplace: "Nuevo mercado",
    marketplaceCreationConfirm: "¿Desea crear el nuevo mercado?",
    createMarketplace: "Crear mercado",
    marketplaceDetails: "Detalles del mercado",
    editMarketplaceCreationConfirm: "Estás a punto de editar los datos del mercado. ¿Estás seguro de que deseas continuar?",
    editMarketplace: "Editar mercado",
    searchCustomer: "Buscar usuario final...",
    customerName: "Nombre del usuario final",
    luckeyCustomersTitle: "Usuarios finales Luckey",
    noCustomerFindTitle: "No se encontraron usuarios finales",
    noCustomerFindDescription: "La lista de usuarios finales está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo",
    noCustomerContractFindTitle: 'No se encontraron contratos de servicio',
    noCustomerContractFindDescription: 'La lista de contratos de servicio está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo',
    newCustomer: "Nuevo usuario final",
    customerCreationConfirm: "¿Desea crear el nuevo usuario final?",
    newUser: "Nuevo usuario",
    userCreationConfirm: "¿Desea crear el nuevo usuario?",
    createCustomer: "Crear usuario final",
    customerDetails: "Detalles del usuario final",
    editCreationConfirm: "Estás a punto de editar los datos del usuario final. ¿Estás seguro de que deseas continuar?",
    editCustomer: "Editar usuario final",
    editCreationUserConfirm: "Estás a punto de editar los datos del usuario. ¿Estás seguro de que deseas continuar?",
    editCustomerContract: 'Editar contrato de servicio',
    editCustomerContractConfirm: '¿Estás a punto de editar los datos del contrato de servicio. ¿Estás seguro de que deseas continuar?',
    newCustomerContract: 'Nuevo contrato de servicio',
    customerContractCreationConfirm: '¿Desea crear el nuevo contrato de servicio?',
    editUser: "Editar usuario",
    customerWallets: "Billeteras de {{customerName}}",
    wallets: 'Billeteras',
    contracts: 'Contratos de servicio',
    plants: 'Dominios',
    newWallet: "Nueva billetera",
    walletCreationConfirm: "¿Desea crear una nueva billetera para el usuario final seleccionado?",
    createWallet: "Crear billetera",
    editWallet: "Editar billetera",
    walletEditConfirm: "¿Desea editar la billetera seleccionada?",
    noWalletFoundTitle: "No se encontró ninguna billetera",
    noWalletFoundDescription: "No se encontró ninguna billetera para el usuario final seleccionado",
    walletDetails: "Detalles de la billetera",
    rechargeWallet: "Recargar",
    walletRechargeHistory: "Historial de recargas",
    rechargeRowTitle: "Créditos modificados",
    rechargeCreditsDescription: "La billetera se ha recargado con {{credits}} créditos",
    rechargeCardDetails: "Detalles de la recarga",
    systemParameters: "Lista de precios",
    systemSubscriptions: "Suscripciones",
    systemSubscriptionsDescription: "Estas son las suscripciones en el sistema. Crea nuevas o asígnalas a un dominio existente",
    newSubscription: "Nueva suscripción",
    editSubscription: "Editar suscripción",
    noSystemSubscriptionFoundTitle: "No se encontró ninguna suscripción",
    noSystemSubscriptionFoundDescription: "No hay ninguna suscripción del sistema que se pueda asignar a un dominio",
    products: "Suscripciones legadas",
    rechargeCards: "Tarjetas de recarga",
    noSystemCardFoundTitle: "No se encontraron tarjetas de recarga",
    noSystemCardFoundDescription: "No hay tarjetas de recarga en el sistema. Crea nuevas para comenzar a recargar las billeteras de los usuarios finales",
    newCard: "Nueva tarjeta de recarga",
    cardStatusUsed: "Usada",
    rechargeCardCreditsDetails: "Esta tarjeta de recarga tiene un valor de {{credits}} créditos",
    cardStatusUnused: "No usada",
    cardStatusInactive: "Deshabilitada",
    enableCard: "Habilitar",
    disabledCardTooltip: "La tarjeta de recarga se habilitará tan pronto como recibas la factura ISEO asociada",
    newTierSubscription: "Nueva suscripción principal",
    pluginAndService: "Complemento y servicios",
    newPluginSubscription: "Nuevo complemento o servicio",
    tierSubscription: "Suscripción principal",
    walletSubscriptions: "Suscripciones",
    noWalletSubscriptionFoundTitle: "No se encontró ninguna suscripción",
    noWalletSubscriptionFoundDescription: "Esta billetera no tiene ninguna suscripción asociada",
    newWalletSubscription: "Asociar nueva suscripción",
    editWalletSubscription: "Editar suscripción",
    newWalletPluginSubscription: "Asociar nuevo complemento o servicio",
    walletConsumption: "Consumo",
    noWalletUsageFoundTitle: "No se encontraron datos",
    noWalletUsageFoundDescription: "No hay datos de consumo para esta billetera",
    ACTIVATION: "Costo de activación del dominio o complemento",
    DAILY_USAGE: "Consumo diario",
    creditConsumptionType: "Tipo de consumo",
    consumptionCreditsDescription: "La billetera ha consumido {{credits}}",
    consumptionRowTitle: "Consumo de la billetera",
    walletPlants: "Dominios",
    noWalletPlantFoundTitle: "No se encontró ningún dominio",
    noWalletPlantFoundDescription: "No hay dominios asociados a esta billetera",
    newWalletPlant: "Nuevo dominio",
    deleteWalletSubscription: "Eliminar suscripción",
    editCard: "Editar tarjeta de recarga",
    rechargeDetails: "Detalles de la recarga",
    exportWalletsUsageCSV: "Exportar CSV de uso de créditos",
    exportWalletsCreditUsageCSV: "Exportar crédito de la billetera",
    PENDING: "Pendiente",
    ACTIVE: "Activo",
    READY_TO_ACTIVATE: "Listo para activar",
    DISABLED: "Deshabilitado",
    walletStatus: "Estado de la billetera",
    exportManagersCSV: "Exportar administradores",
    needCreditsToCreatePlant: "Necesitas créditos en esta billetera para crear un nuevo dominio"
  },
  sales: {
    hardwareSalesInfo: "Información de ventas",
    domain: "Dominio",
    hardwareId: "ID de HW",
    hardwareName: "Nombre de HW",
    hardwareSerialNumber: "Número de serie de HW",
    hardwareModel: "Modelo de HW",
    hardwareVendor: "Línea de productos de HW",
    hardwareType: "Tipo de HW",
    sfdcId: "SFDC-ID",
    iseoSelloutOrderId: "ID de orden de venta ISEO",
    iseoSelloutOrderDate: "Fecha de orden de venta ISEO",
    iseoSelloutInvoiceId: "ID de factura de venta ISEO",
    iseoSelloutInvoiceDate: "Fecha de factura de venta ISEO",
    sofiaCustRef: "Ref. Cliente (proceso Sofia)",
    unreconciledHardware: "Hardware no conciliado",
    hardwareWithSalesInfo: "Hardware con información de ventas",
    actions: "Acciones",
    addSalesInfo: "Agregar información de ventas",
    editSalesInfo: "Editar información de ventas",
    iseoSelloutOrder: "Orden de venta ISEO",
    iseoSelloutInvoice: "Factura de venta ISEO",
    selectedSalesInfoError: "¡Advertencia! La selección no es homogénea. ¿Estás seguro de que deseas continuar?"
  },
  errors: {
    errorPreviewingFile: 'Error al previsualizar el archivo. Verifica el formato de archivo o intenta subir un archivo diferente',
    fileFormatNotSupported: 'Formato de archivo no soportado',
    deleteWalletSubscriptionError: "Ocurrió un error al modificar la suscripción. Por favor, inténtalo de nuevo o contacta a nuestro equipo de soporte",
    modifyVarOpportunityError: "Ocurrió un error al editar la cotización. Por favor, inténtalo de nuevo",
    error: "Error",
    loginFailed: "La sesión ha expirado. Por favor, inicia sesión nuevamente",
    loginGoogleFailedTitle: "Error de inicio de sesión con Google",
    loginGoogleFailed: "Asegúrate de haber iniciado sesión en tu cuenta de Google o intenta abrir esta página en una sesión de Google Chrome con tu cuenta de GSuite de Sofia",
    loginJagoGoogleFailedTitle: "Error de inicio de sesión con Jago Google",
    loginJagoGoogleFailed: "Asegúrate de tener un usuario en Jago que corresponda a tu cuenta de GSuite de Sofia e inténtalo de nuevo",
    getDomainDetailsError: "Ocurrió un error al obtener la configuración de los dominios. Por favor, inténtalo de nuevo o contacta al soporte de Sofia",
    updateDomainConfigError: "Ocurrió un error al guardar la configuración del dominio. Por favor, inténtalo de nuevo o contacta al soporte de Sofia",
    updatePlantThemeError: "Ocurrió un error al guardar el tema del dominio. Por favor, inténtalo de nuevo o contacta al soporte de Sofia",
    impersonateDomainUserError: "Ocurrió un error al personificar el usuario. Por favor, verifica que el usuario esté activo e inténtalo de nuevo o contacta al soporte de Sofia",
    createDomainError: "Ocurrió un error al crear el nuevo dominio",
    addDomainPluginError: "Ocurrió un error al extender el dominio",
    addUserDomainError: "No se pudo crear el usuario. Verifica si el usuario ya existe en el dominio o si el dominio tiene una suscripción válida",
    deleteDomainUserError: "No se pudo eliminar el usuario. Por favor, inténtalo de nuevo",
    errorSaveAdditionalInfo: "No se pudo actualizar la información en el dominio seleccionado",
    createCustomerError: "No se pudo crear el usuario final. Verifica si el usuario final ya existe e inténtalo de nuevo",
    createCustomerContractError: 'No se pudo crear el contrato de servicio. Verifica los datos e inténtalo de nuevo',
    getCustomerContractDetailsError: 'No se pudieron obtener los detalles del contrato de servicio. Por favor, inténtalo de nuevo',
    createUserError: "No se pudo crear el usuario. Verifica si el usuario ya existe e inténtalo de nuevo",
    createVarUserError: "No se pudo crear el usuario VAR. Verifica si el usuario ya existe e inténtalo de nuevo",
    createPlantThemeError: "No se pudo crear el tema del dominio. Verifica los datos e inténtalo de nuevo",
    updateVarError: "No se pudo actualizar. Verifica los datos e inténtalo de nuevo",
    getCustomerDetailsError: "No se pudieron obtener los detalles del usuario final. Por favor, inténtalo de nuevo",
    getVarDetailsError: "No se pudieron obtener los detalles del VAR. Por favor, inténtalo de nuevo",
    getPlantThemeDetailsError: "No se pudieron obtener los detalles del tema del dominio. Por favor, inténtalo de nuevo",
    getProductInfoPostDetailsError: "No se pudo obtener el Artículo. Por favor, inténtalo de nuevo",
    required: "Requerido",
    deleteDomainRequestError: "No se pudo enviar la solicitud. Por favor, inténtalo de nuevo",
    deleteWalletRequestError: "No se pudo enviar la solicitud. Por favor, inténtalo de nuevo",
    deleteCustomerRequestError: "No se pudo enviar la solicitud. Por favor, inténtalo de nuevo",
    enableIrisDomainRequestError: "No se pudo enviar la solicitud. Por favor, inténtalo de nuevo",
    updatePlantDetailsError: "No se pudieron actualizar los detalles de la instalación. Por favor, inténtalo de nuevo",
    createCustomerWalletError: "No se pudo crear la nueva billetera. Por favor, inténtalo de nuevo",
    editCustomerWalletError: "No se pudo editar la nueva billetera. Por favor, inténtalo de nuevo",
    getWalletDetailsError: "No se pudieron recuperar los detalles de la billetera. Por favor, inténtalo de nuevo",
    openSystemParametersError: "No se pudieron abrir los parámetros del sistema. Por favor, inténtalo de nuevo",
    createSubscriptionError: "No se pudo crear la suscripción. Por favor, inténtalo de nuevo",
    createCardError: "Ocurrió un error al crear la tarjeta de recarga. Por favor, inténtalo de nuevo",
    createVarOpportunityError: "Ocurrió un error durante la creación. Por favor, inténtalo de nuevo",
    editVarOpportunityError: "Ocurrió un error durante la operación. Por favor, inténtalo de nuevo",
    rechargeWalletError: "Ocurrió un error al recargar la billetera. Por favor, inténtalo de nuevo",
    deleteCardError: "Ocurrió un error al eliminar la tarjeta de recarga. Por favor, inténtalo de nuevo",
    enableCardError: "Ocurrió un error al actualizar la tarjeta de recarga. Por favor, inténtalo de nuevo",
    deletePlantThemeError: "Ocurrió un error al eliminar. Por favor, inténtalo de nuevo",
    deleteVarUserError: "Ocurrió un error al eliminar. Por favor, inténtalo de nuevo",
    deleteVarUserErrorOpportunities: "Este usuario es el propietario de al menos una cotización, por lo que no se puede eliminar. Por favor, reasigna las cotizaciones asociadas a este usuario e inténtalo de nuevo.",
    deleteVarOpportunityError: "Ocurrió un error al eliminar. Por favor, inténtalo de nuevo",
    rejectVarOpportunityError: "Ocurrió un error al actualizar la cotización. Por favor, inténtalo de nuevo",
    approveVarOpportunityError: "Ocurrió un error al actualizar la cotización. Por favor, inténtalo de nuevo",
    syncsfdcidVarOpportunityError: "Ocurrió un error al actualizar la cotización. Por favor, inténtalo de nuevo",
    upgradeVarOpportunityError: "Ocurrió un error al actualizar la cotización. Por favor, inténtalo de nuevo",
    winVarOpportunityError: "Ocurrió un error al actualizar la cotización. Por favor, inténtalo de nuevo",
    loseVarOpportunityError: "Ocurrió un error al actualizar la cotización. Por favor, inténtalo de nuevo",
    deleteUserError: "Ocurrió un error al eliminar. Por favor, inténtalo de nuevo",
    createWalletSubscriptionError: "Ocurrió un error al asociar la suscripción a la billetera. Por favor, inténtalo de nuevo",
    createWalletPlantError: "Ocurrió un error al crear el dominio para la billetera. Por favor, inténtalo de nuevo",
    walletActionErrorNotEnoughCreditsTitle: "Crédito insuficiente",
    walletActionErrorNotEnoughCredits: "La billetera no tiene suficientes créditos para realizar la operación. Verifica la operación que estás realizando e inténtalo de nuevo",
    warningMinCreditsCard: "¡Advertencia! Número mínimo de créditos requeridos = {{credits}}",
    loginJagoOTPEmailFailedTitle: "Error al enviar el correo",
    loginJagoOTPEmailFailed: "Ocurrió un error al enviar el correo, inténtalo de nuevo después de 5 minutos",
    loginJagoOTPFailedTitle: "Error de verificación de código",
    loginJagoOTPFailed: "La verificación del código de acceso no fue exitosa. Por favor, verifica el código o intenta el inicio de sesión de nuevo después de 5 minutos.",
    addonV364missing: "No se pudo encontrar el complemento V364 en el sistema, por favor, reporta este error para recibir asistencia.",
    openIseoTrainingMaterialsError: "Se produjo un error al cargar los materiales de formación ISEO. Por favor, inténtalo de nuevo"
  },
  gateways: {
    deployments: 'Deployments',
    showDeployments: 'Mostrar Deployments',
    showLogs: 'Show Logs',
    gatewayLogsTitle: 'Gateway logs',
    gatewayLogsTimestamp: 'Time',
    gatewayLogsLevel: 'Level',
    gatewayLogsLevelFilter: 'Nivel de registro',
    gatewayLogsLevelFilterAll: 'Todos',
    gatewayLogsLevelError: '4 (Error)',
    gatewayLogsLevelInfo: '6 (Info)',
    gatewayLogsSummary: 'Summary',
    gatewayLogsContext: 'Context',
    gatewayLogsFullLine: 'Full line',
    gatewayLogsMessage: 'Message',
    gatewayLogsEmpty: 'No log lines found for this device in the selected time range.',
    gatewayLogsRefresh: 'Refresh',
    gatewayLogsDeviceIdLabel: 'Device',
    gatewayLogsFilterContext: 'Filter context',
    gatewayLogsFilterContextPlaceholder: 'Contains…',
    gatewayLogsFilterText: 'Search in log',
    gatewayLogsFilterTextPlaceholder: 'Filter in full line, summary…',
    gatewayLogsDateFrom: 'From',
    gatewayLogsDateTo: 'To',
    gatewayLogsApplyRange: 'Apply range',
    gatewayLogsRangeHint: 'Max span between From and To dates: 8 calendar days',
    gatewayLogsNoFilterMatch: 'No rows match the current filter.',
    gatewayLogsErrorGeneric: 'Could not load gateway logs from the server. Please try again.',
    getGatewayDeploymentsError: 'Ocurrió un error al obtener los Deployments. Por favor, inténtalo de nuevo',
    createdBy: 'Creado por',
    noGatewayFoundTitle: 'No se encontró ningún HyperGate',
    noGatewayFoundDescription: 'La lista de HyperGate está vacía. Si has establecido un filtro de búsqueda, intenta modificarlo y volver a intentarlo',
    gatewayName: 'Nombre de HyperGate',
    luckeyGatewaysTitle: 'Sistema HyperGates',
    lastConnectionDate: 'Última conexión: {{ date }}',
    gatewaysDevices: 'Dispositivos',
    gatewaysArtifacts: 'Artifacts',
    gatewaysDeployments: 'Deployments',
    noArtifactFoundTitle: 'No se encontró ningún Artifact',
    noArtifactFoundDescription: 'La lista de Artifacts está vacía. Si has establecido un filtro de búsqueda, intenta modificarlo y volver a intentarlo',
    noDeploymentFoundTitle: 'No se encontró ningún Deployment',
    noDeploymentFoundDescription: 'La lista de Deployments está vacía. Si has establecido un filtro de búsqueda, intenta modificarlo y volver a intentarlo',
    newDeployment: 'Nuevo Deployment',
    deploymentScheduledAt: 'Deployment programado para',
    gatewaysArtifact: 'Artifact',
    gateways: 'Gateways',
    artifactName: 'Nombre del Artifact',
    createNewDeployment: 'Crear nuevo Deployment',
    selectHyperGates: 'Seleccionar HyperGates',
    allGateways: 'Deployar en todos los HyperGates',
    HYPERGATE_PRO: 'HyperGate Pro',
    HYPERGATE_ISEO: 'HyperGate Lite',
    deploymentDetail: 'Detalles del Deployment',
    noDeploymentDetailedFound: 'No se encontró ningún HyperGate para el Deployment',
    noDeploymentDetailedFoundDescription: 'La lista de HyperGates para este Deployment está vacía',
    DONE: 'Completado',
    PENDING: 'En progreso',
    IN_PROGRESS: 'En instalación',
    ERROR: 'Error',
    deviceId: 'ID del dispositivo',
    name: 'Nombre',
    gatewayVersion: 'Versión',
    iseoSdkVersion: 'ISEO SDK',
    kernelVersion: 'Versión del kernel',
    serialNumber: 'Número de serie',
    noGatewaysFound: 'No se encontró ningún HyperGate',
    noGatewaysFoundDescription: 'La lista de HyperGates está vacía. Intenta modificar el filtro de búsqueda y volver a intentarlo',
    noDeploymentFound: 'No Deployment',
    noArtifactFound: 'No Artifact',
  },
  forms: {
    createResource: 'Crear recurso',
    subscriptionCategory: 'Categoría',
    createNew: 'Nuevo',
    aggregateByMonth: 'Agregado por mes',
    findOutMore: 'Descubre más',
    findOutMoreAboutThisFeature: 'Descubre más sobre esta funcionalidad',
    extraCredentials: 'Credenciales extra',
    invitations: 'Invitaciones activas',
    anonymizeAllEvents: 'Eliminar datos del usuario de Eventos de Cerraduras Inteligentes y Eventos de Gestión',
    deleteAllStandardDevices: 'Eliminar todas las tarjetas RFID, códigos PIN y llaves F9000 asignadas a este usuario',
    numberOfDomains: 'Dominios',
    walletDetails: 'Detalles de la billetera',
    subscriptionDetails: 'Detalles de la suscripción',
    smartLocks: 'Cerraduras',
    users: 'Usuarios',
    numberOfElements: 'Elementos',
    segment: 'Segmento',
    otpLoginOnly: 'Habilitar inicio de sesión exclusivamente con OTP para este sistema',
    varEditSuccess: 'VAR actualizado con éxito',
    synchronizationCompleted: 'Sincronización completada con éxito',
    sfdcSync: 'Sincronización SFDC',
    customerVatVerificationTitle: 'Recuperar datos del cliente desde los sistemas ISEO',
    customerAdditionalData: 'Datos adicionales',
    verify: 'Verificar',
    otp: 'OTP',
    notVisible: "No visible",
    visible: "Visible",
    exportAllUsers: "Exportar usuarios",
    montlyBurnRate: "{{credits}}/mes",
    nextRechargeForecast: "Próxima recarga esperada con el consumo actual ~{{date}}",
    creditsFinishedInDate: "Créditos terminados el {{date}}",
    lastUpdate: "Última actualización {{time}}",
    rowsPerPage: "Filas por página",
    rolePermissions: "Permisos de rol",
    permissionsDetails: "Detalles de permisos",
    clusterAndIseoCompany: "Cluster y empresa ISEO",
    createCardSuccess: "Tarjeta de recarga creada con éxito",
    cardDetails: "Detalles de la tarjeta",
    status: "Estado",
    customerInfo: "Información del cliente",
    details: "Detalles",
    costs: "Costos",
    hostName: "Nombre del host",
    domainType: "Tipo",
    user: "Usuario",
    logoutConfirmation: "¿Estás seguro de que deseas cerrar sesión?",
    send: "Enviar",
    askQuestion: "Contáctanos",
    ticketOpenSuccessfully: "¡Tu pregunta ha sido enviada a nuestro equipo! Uno de nuestros miembros se pondrá en contacto contigo en breve.",
    ticketOpenError: "Ocurrió un error al enviar la solicitud. Por favor, inténtalo de nuevo",
    writeUsAQuestionDescription: "¿Tienes alguna pregunta? Siéntete libre de escribirnos, y uno de nuestros Especialistas de Producto estará listo para asistirte con cualquier consulta que puedas tener.",
    deviceType: "Tipo de dispositivo",
    createNewMarketplace: "Nuevo mercado",
    createNewCustomer: "Nuevo",
    firstName: "Nombre",
    lastName: "Apellido",
    email: "Correo electrónico",
    contactEmail: "Correo de contacto",
    marketplace: "Mercado",
    open: "Abrir",
    add: "Agregar",
    actions: "Acciones",
    search: "Buscar",
    remove: "Eliminar",
    error: "Error",
    copy: "Copiar",
    cancel: "Cancelar",
    confirm: "Confirmar",
    warning: "Advertencia",
    reset: "Restablecer",
    close: "Cerrar",
    save: "Guardar",
    delete: "Eliminar",
    duplicate: "Duplicar",
    deleteRequest: "Enviar solicitud de eliminación",
    deleteAdminOnly: "Eliminar (admin)",
    export: "Exportar",
    spinnerLoading: "Cargando...",
    createNewDomain: "Crear nuevo dominio",
    walletName: "Nombre de la billetera",
    domainName: "Nombre de dominio",
    domainNamePreview: "Vista previa",
    domainFormTitle: "Crear un nuevo dominio Luckey",
    invalidDomainName: "Etiqueta de dominio no válida. Hasta 50 caracteres: letras y números, guion solo entre caracteres (no al inicio ni al final), sin espacios",
    selectProduct: "Selecciona un tipo de suscripción",
    name: "Nombre",
    lastname: "Apellido",
    createNewUser: "Crear nuevo administrador",
    selectRole: "Selecciona el rol del usuario",
    createUserForDomain: "Crear un nuevo usuario para el dominio seleccionado",
    newUser: "Nuevo usuario",
    password: "Contraseña",
    letUserChoosePassword: "Permitir que el usuario elija su contraseña: enviar enlace para configurar la contraseña al correo del usuario",
    domainCreateSuccess: "Dominio creado con éxito",
    domainCreateUserAfterCreation: "¿Desea crear un usuario para el nuevo dominio?",
    domainCreationConfirm: "¿Desea crear el nuevo dominio?",
    createDomain: "Crear dominio",
    username: "Nombre de usuario",
    domainExtendsConfirm: "¿Desea extender el dominio con el producto seleccionado?",
    createNewInstaller: "Crear nuevo instalador",
    createInstallerForDomain: "Crear un nuevo usuario instalador para el dominio",
    deleteDomain: "Solicitar eliminación del dominio",
    active: "Activo",
    disabled: "Deshabilitado",
    minutes: "{{minutes}} minutos",
    selectSessionDurationPlaceholder: "Duración de la sesión",
    impersonateUserDescription: "Antes de personificar al usuario dentro del sistema, te informamos que:",
    impersonateUserDescriptionOne: "El inicio de la sesión y su duración aparecerán en los registros del dominio",
    impersonateUserDescriptionTwo: "Cada acción que realices será registrada y aparecerá en los registros del sistema",
    impersonateUserDescriptionThree: "Cualquier acción que realices en el implante tendrá un efecto inmediato y, en algunos casos, irreversible",
    selectSessionDuration: "Selecciona la duración de la sesión de soporte",
    impersonateReadOnly: "Modo solo lectura",
    impersonateReadOnlyDescription: "Accede al sistema en modo solo lectura, podrás ver los datos del sistema pero sin poder modificarlos",
    impersonateReadOnlyWarning: "Atención: La sesión de soporte y su duración seguirán siendo visibles en los registros del sistema",
    installationModeActive: "Activo",
    installationModeDisabled: "Deshabilitado",
    customerFormTitle: "Usuario final Luckey",
    customerContractFormTitle: 'Contrato de servicio',
    varFormTitle: "Distribuidor de valor agregado (VAR)",
    varFormAdminSection: "Sección de administración",
    varFormTitleVar: "Información de la empresa",
    plantThemeFormTitle: "Tema de dominio Luckey",
    customerName: "Nombre del usuario final",
    invalidCustomerName: "Nombre del usuario final no válido",
    createNewWallet: "Nueva billetera",
    whatsNewTitle: "¡Novedades de Luckey!",
    whatsNewSubtitle: "Descubre las últimas noticias sobre Luckey y Sofia, parte de ISEO",
    notes: "Notas adicionales",
    cardCode: "Código de recarga",
    recharge: "Recargar",
    rechargeWalletFormDescription: "Recarga los créditos de esta billetera ingresando el código de recarga. La recarga se aplicará de inmediato",
    subscriptionName: "Nombre de la suscripción",
    subscriptionFixedPrice: "Costo de activación (créditos)",
    subscriptionBurnRate: "Costo recurrente (créditos)",
    subscriptionVisible: "Visible en el mercado",
    createNewSubscriptionDescription: "Crea una nueva suscripción en el sistema. La suscripción estará disponible para todos los dominios",
    subscriptionLogicDescription: "Indica qué elementos del sistema se contarán para determinar las restricciones del sistema",
    FIXED: "No imponer restricciones a los elementos",
    COUNT_USERS_LOCKS: "Limitar el número de usuarios y cerraduras del dominio",
    COUNT_LOCKS: "Solo limitar el número de cerraduras del dominio",
    COUNT_ELEMENTS: "Limitar la suma de cerraduras y usuarios del dominio",
    maxLocks: "Número máximo de cerraduras inteligentes",
    maxUsers: "Número máximo de usuarios",
    maxElements: "Número máximo de elementos (usuarios+cerraduras)",
    subscriptionLogic: "Lógica de límite de elementos",
    selectLogic: "Seleccionar",
    subscriptionMaxLocksDescription: "Inserte el número máximo de cerraduras que se pueden instalar con esta suscripción",
    subscriptionMaxUsersDescription: "Inserte el número máximo de usuarios que se pueden activar con esta suscripción",
    subscriptionMaxElementsDescription: "Inserte el número máximo de elementos con esta suscripción",
    subscriptionResource: "Recurso",
    cardQuantity: "Número de créditos",
    cardQuantityDescription: "Indica el número de créditos que se recargarán al usar la tarjeta de recarga",
    cardVar: "Asignar tarjeta de recarga al VAR",
    cardWallet: "Asignar tarjeta de recarga a una billetera específica",
    cardNotes: "Notas adicionales",
    createCardConfirm: "¿Estás seguro de que deseas crear la tarjeta de recarga?",
    createVarOpportunityConfirm: "¿Estás seguro de que deseas crear esta nueva cotización?",
    createSubscrptionConfirm: "¿Estás seguro de que deseas crear la nueva suscripción?",
    rechargeWalletConfirm: "Estás a punto de recargar la billetera de este usuario final con nuevos créditos, ¿deseas continuar? La operación no se puede deshacer",
    createdAt: "Fecha de creación",
    copiedSuccess: "¡Copiado!",
    logout: "Cerrar sesión",
    deleteCardConfirm: "¿Estás seguro de que deseas eliminar esta tarjeta de recarga? La operación no se puede deshacer",
    enableCardConfirm: "¿Estás seguro de que deseas habilitar esta tarjeta de recarga? Una vez habilitada, esta tarjeta podrá ser utilizada. La operación no se puede deshacer",
    subscriptionTierSelectionTitle: "Suscripción principal",
    subscriptionTierSelectionDescription: "Al seleccionar la suscripción principal, el nuevo complemento heredará automáticamente las lógicas de conteo de la suscripción principal",
    selectTier: "Seleccionar suscripción",
    createPluginSubscriptionConfirm: "¿Estás seguro de que deseas crear esta nueva suscripción de complemento/servicio?",
    createWalletSubscriptionConfirm: "¿Estás seguro de que deseas asociar esta suscripción a la billetera seleccionada? La suscripción se activará para todos los dominios gestionados a través de esta billetera",
    deleteWalletSubscriptionConfirm: "¿Estás seguro de que deseas eliminar esta suscripción de la billetera seleccionada? La suscripción se eliminará de todos los dominios gestionados a través de esta billetera",
    editSubscriptionConfirm: "¿Estás seguro de que deseas editar la suscripción?",
    walletSelectSubscriptionTitle: "Suscripción a activar",
    walletSelectSubscriptionDescription: "Selecciona la suscripción a activar en esta billetera. Recuerda que la suscripción también se activará en todos los sistemas gestionados a través de esta billetera",
    createWalletPlantConfirm: "¿Estás seguro de que deseas crear el nuevo dominio para la billetera seleccionada?",
    enableEmailForPlant: "Habilitar servicio de correo",
    enableEmailForPlantDescription: "Habilita el envío de correos para este sistema (correo de activación, notificaciones, etc.)",
    enableIrisRequiredForPlant: "Requerir servicio 1ris",
    enableIrisRequiredForPlantDescription: "Si se selecciona, el dominio se preparará para incluir el servicio 1ris",
    cardSubscriptionsLinked: "Suscripciones asociadas",
    cardSubscriptionsLinkedDescription: "Asocia múltiples complementos o servicios a esta tarjeta de recarga para activarlos una vez que la tarjeta sea usada",
    mainTierDescription: "Asocia una suscripción principal a esta tarjeta de recarga para activarla una vez que la tarjeta sea usada",
    cardMarketplacesLinked: "Mercado para la asociación de licencias",
    cardMarketplacesLinkedDescription: "Selecciona un mercado para elegir las suscripciones a asociar a esta tarjeta de recarga",
    sku: "SKU",
    customerData: "Datos del usuario final",
    customerVat: "IVA",
    customerFiscalCode: "Código fiscal",
    customerCountry: "País",
    customerAddress: "Dirección",
    customerCity: "Ciudad",
    customerEmail: "Correo electrónico",
    customerPhone: "Teléfono",
    customerCrmId: "ID DE CUENTA SFDC",
    customerMarketplace: "Mercado",
    customerCertifiedEmail: "PEC (Correo certificado)",
    customerCluster: "Cluster",
    customerVar: "VAR",
    customerCompany: "Empresa ISEO",
    customerPostalCode: "Código postal",
    customerPrincipalSubDivision: "Provincia, Estado, Condado, etc.",
    iseoSalesOrderReference: "Orden de venta ISEO (ISEO -> Cliente)",
    iseoSalesOrderDate: "Fecha de orden de venta ISEO",
    iseoPurchaseOrderReference: "Orden de compra ISEO (ISEO -> Sofia)",
    iseoPurchaseOrderDate: "Fecha de orden de compra ISEO",
    sofiaSalesOrderReference: "Orden de venta Sofia (Sofia -> ISEO)",
    sofiaSalesOrderDate: "Fecha de orden de venta Sofia",
    pickDate: "Elegir fecha",
    crmSource: "Fuente de oportunidad CRM",
    crmId: "Identificador único de oportunidad CRM",
    sofiaProjectId: "Identificador de referencia del proyecto Sofia",
    crmLink: "URL a la oportunidad CRM",
    kamReference: "Referencia KAM",
    edit: "Editar",
    editCardConfirm: "¿Estás seguro de que deseas editar la tarjeta de recarga?",
    editVarOpportunityConfirm: "¿Estás seguro de que deseas editar esta cotización?",
    insertEmailOTPLoginForm: "Introduce el correo de tu cuenta para recibir el código OTP y acceder a la plataforma",
    insertEmailOTPLoginFormDisclaimer: "Si el correo está autorizado, recibirás un código OTP para acceder",
    insertOTPOTPLoginForm: "Introduce el código OTP recibido en el correo de tu cuenta",
    insertOTPOTPLoginFormDisclaimer: "En caso de que no hayas recibido el código después de 5 minutos, repite la operación",
    pickDateTo: "Elegir fecha hasta:",
    pickDateFrom: "Elegir fecha desde",
    AUTOMATIC: "Activación automática",
    MANUAL: "Activación manual",
    SEMI_AUTOMATIC: "Activación semiautomática",
    AUTOMATIC_Description: "La extensión se puede activar de forma independiente desde la tienda por el usuario. Los créditos de activación se deducirán de inmediato",
    MANUAL_Description: "Extensión que solo se puede activar tras una solicitud explícita del usuario final. Los créditos se deducirán manualmente tras la aprobación de la solicitud",
    SEMI_AUTOMATIC_Description: "Extensión que solo se puede activar tras una solicitud explícita del usuario final. Los créditos de activación se deducirán en el momento de la solicitud",
    requestToQuote: "Cotización solicitada",
    requestToQuoteDescription: "Indica si la extensión está sujeta a cotización en lugar de uso directo de créditos (por ejemplo, integraciones y personalizaciones)",
    subscriptionCanBeDeactivated: "Se puede desactivar desde el administrador",
    subscriptionCanBeDeactivatedDescription: "Indica si el administrador puede desactivar la suscripción desde Luckey Store",
    selectSegmentType: "Selecciona el segmento",
    sofiaInvoiceNumber: "Número de factura de Sofia",
    sofiaInvoiceAmount: "Monto de la factura de Sofia",
    sofiaInvoiceYear: "Año de la factura de Sofia",
    iseoInvoiceNumber: "Número de factura ISEO",
    iseoInvoiceAmount: "Monto de la factura ISEO",
    iseoInvoiceYear: "Año de la factura ISEO",
    freeOfCharge: "Gratuito",
    freeOfChargeReason: "Motivo",
    currency: "Moneda",
    sofiaInvoiceDate: "Fecha de factura",
    iseoInvoiceDate: "Fecha de factura",
    sofiaInvoiceRecipient: "Destinatario de la factura",
    iseoInvoiceRecipient: "Destinatario de la factura",
    serviceSupplementaryInvoice: "Factura suplementaria del servicio",
    serviceSupplementaryInvoiceNumber: "Número de factura",
    serviceSupplementaryInvoiceAmount: "Monto de la factura",
    serviceSupplementaryInvoiceDate: "Fecha de factura",
    serviceSupplementaryInvoiceRecipient: "Destinatario de la factura",
    iseoInvoiceIssuer: "Emisor de la factura",
    backdropClosing: "¿Estás seguro de que deseas cerrar el formulario sin guardar?",
    roles: "Roles",
    selectBotType: 'Seleccionar tipo de asistente',
    helperBot: 'Asistente técnico',
    commercialBot: 'Asistente comercial',
    talkWithUs: 'Asistente IA',
    noBotTypeSelected: 'No se ha seleccionado ningún tipo de asistente',
    invalidEmail: 'Por favor, ingrese una dirección de correo electrónico válida',
    customer: 'End-user standard',
    simplifiedCustomer: 'End-user semplificado',
  },
  activations: {
    cluster: 'Cluster',
    clusters: 'Clusters',
    getInfo: "(Obtener más información sobre el proceso)",
    createNewCustomer: "Crear usuario final",
    createNewWallet: "Crear billetera",
    createNewScratchcard: "Crear tarjeta de recarga",
    yearsString: "años",
    monthsString: "meses",
    daysString: "días",
    addNewActivationButton: "Agregar activación del sistema",
    home: "Inicio OD",
    activationRequests: "Activaciones del sistema",
    rechargeRequests: "Recargas de billetera",
    walletStatus: "Estado de las órdenes",
    noActivationsFoundTitle: "No se encontraron activaciones del sistema",
    noActivationsFoundDescription: "No hay activaciones del sistema en el sistema. Crea nuevas para comenzar",
    selloutOrder: "Orden de venta",
    intragroupOrder: "Orden intra-grupo",
    custref: "Ref. Cliente",
    rejectedReason: "Motivo de rechazo",
    changeStatusToUnderReview: "Enviar a revisión",
    changeStatusToInvoiced: "Enviar a facturado",
    changeStatusToCreated: "Enviar a creado",
    changeStatusToRejected: "Rechazar solicitud",
    changeStatusToProcessing: "Aceptar solicitud",
    changeStatusAdmin: "Establecer estado (admin)",
    changeCustRef: "Establecer Ref. Cliente",
    search: "Buscar...",
    resetFilters: "Restablecer filtros",
    statusSelection: "Cualquier estado",
    clusterSelection: "Cualquier cluster",
    statusDRAFT: "Borrador",
    statusUNDER_REVIEW: "Bajo revisión",
    statusREJECTED: "Rechazado",
    statusPROCESSING: "En proceso",
    statusCREATED: "Creado",
    statusINVOICED: "Facturado",
    statusACTIVE: "Activo",
    statusDELETED: "Eliminado",
    promote: "Eliminar",
    saveDraft: "Guardar como borrador",
    customMarketplaceWarning: "El usuario final no está asociado al mercado predeterminado. Necesitarás especificar manualmente la suscripción base solicitada y los complementos en la sección 'Notas'",
    subscriptionNotFoundError: "No se encontró la suscripción",
    deleteActivationConfirm: "¿Estás seguro de que deseas eliminar esta activación del sistema? La operación no se puede deshacer",
    deleteActivationError: "Ocurrió un error al eliminar la activación del sistema. Por favor, inténtalo de nuevo",
    promoteActivationConfirm: "¿Estás seguro de que deseas enviar esta activación del sistema a revisión? La solicitud de activación del sistema no se puede editar mientras esté en revisión.",
    promoteActivationError: "Ocurrió un error al promover la activación del sistema. Por favor, inténtalo de nuevo",
    createdActivationConfirm: "¿Estás seguro de que deseas enviar esta activación del sistema al estado CREADO?",
    createdActivationError: "Ocurrió un error al actualizar el estado de la activación del sistema. Por favor, inténtalo de nuevo",
    invoicedActivationConfirm: "¿Estás seguro de que deseas marcar esta activación del sistema como facturada?",
    invoicedActivationError: "Ocurrió un error al actualizar el estado de la activación del sistema. Por favor, inténtalo de nuevo",
    editStatusActivationConfirm: "¿Estás seguro de que deseas editar el estado de esta activación del sistema? La operación no se puede deshacer",
    editStatusActivationError: "Ocurrió un error al actualizar el estado de la activación del sistema. Por favor, inténtalo de nuevo",
    rejectActivationConfirm: "Especifica el motivo para rechazar esta solicitud.",
    rejectActivationError: "Ocurrió un error al rechazar la activación del sistema. Por favor, inténtalo de nuevo",
    processingActivationConfirm: "¿Estás seguro de que deseas aceptar esta activación del sistema?",
    processingActivationError: "Ocurrió un error al aceptar la activación del sistema. Por favor, inténtalo de nuevo",
    newFileName: "Especifica el nombre del archivo",
    newFileExtensionError: "El archivo tiene una extensión no soportada",
    newFileDuplicateNameError: "Este nombre ya ha sido utilizado para otro archivo. Cambia el nombre y repite la operación.",
    editCustrefConfirm: "Especifica la Ref. Cliente para esta solicitud.",
    editCustrefError: "Ocurrió un error al actualizar la Ref. Cliente, por favor, inténtalo de nuevo",
    editActivation: "Editar activación del sistema",
    newActivation: "Agregar activación del sistema",
    viewActivation: "Ver activación del sistema",
    newActivationError: "Ocurrió un error al crear esta activación del sistema. Por favor, inténtalo de nuevo",
    editActivationError: "Ocurrió un error al actualizar esta activación del sistema. Por favor, inténtalo de nuevo",
    customerSearch: "Buscar entre usuarios finales existentes",
    customerSearchEnterName: "Buscar por nombre...",
    customerSearchNoMatch: "No se encontraron usuarios finales...",
    customerProceedWithSelected: "Usar usuario final seleccionado",
    customerProceedWithNew: "Crear nuevo usuario final",
    customerConfirmData: "Confirmar datos del usuario final",
    customerData: "Datos del cliente",
    varData: "Datos del VAR",
    selectCustomerOrVar: "Selecciona el objetivo para esta solicitud (usuario final o VAR)",
    varSfdcId: "ID DE CUENTA SFDC",
    varName: "Nombre",
    varSearch: "Buscar entre los VAR existentes",
    varSearchEnterName: "Buscar por nombre...",
    varSearchNoMatch: "No se encontró ningún VAR...",
    varCustomerSearch: "Buscar entre los usuarios finales del VAR",
    varProceedWithSelected: "Usar VAR seleccionado",
    customerFormTitle: "Usuario final Luckey",
    customerName: "Nombre del usuario final",
    customerVat: "IVA",
    customerFiscalCode: "Código fiscal",
    customerCountry: "País",
    customerAddress: "Dirección",
    customerCity: "Ciudad",
    customerEmail: "Correo electrónico",
    customerPhone: "Teléfono",
    customerCrmId: "ID DE CUENTA SFDC",
    customerMarketplace: "Mercado",
    customerCertifiedEmail: "PEC (Correo certificado)",
    customerCluster: "Cluster",
    customerVar: "VAR",
    customerCompany: "Empresa ISEO",
    customerPostalCode: "Código postal",
    customerPrincipalSubDivision: "Provincia, Estado, Condado, etc.",
    exportActivationsCSV: "Exportar CSV",
    salesAndOrdersData: "Ventas y Órdenes",
    basicData: "Información del dominio",
    formEnterAnswer: "Tu respuesta",
    formEnterAnswerGT0: "Número mayor que cero",
    formEnterAnswerFrom0To600: "Número entre 0 y 600",
    formEnterAnswerOwnerEmail: "Correo del propietario",
    formEnterAnswerKamEmail: "Correo del Key Account Manager",
    formEnterAnswerPmEmail: "Correo del PM",
    formEnterAnswerSystemEngineerEmail: "Correo del Ingeniero de Sistemas",
    optId: "ID de oportunidad (SFDC)",
    salesOrderConfirmationNumber: "Número de confirmación de orden de venta (venta)",
    salesOrderConfirmationNumber_desc: "",
    selloutFiles: "Orden de venta PDF (hardware + software + servicios profesionales)",
    selloutFiles_desc: "Necesario para rastrear correctamente los ingresos de Blossom.",
    selloutFiles_desc2: "Límite de archivos: 5  ~  Tamaño máximo de cada archivo: 10MB  ~  Extensiones permitidas: ",
    selloutFilesAdd: "Subir archivo",
    selloutFilesDownload: "Descargar",
    selloutFilesReplace: "Reemplazar",
    quotationToolFile: "Herramienta de cotización (no obligatoria)",
    quotationToolFile_desc: "Sube el archivo de la herramienta de cotización utilizado para esta solicitud.",
    quotationToolFile_desc2: "Límite de archivos: 1  ~  Tamaño máximo de cada archivo: 10MB",
    purchaseOrderNumberSofia: "Número de Orden de Compra a Sofia",
    baselineSubscription: "Suscripción base Luckey",
    baselineSubscription_BASIC: "Luckey Básico",
    baselineSubscription_ENTERPRISE: "Luckey Enterprise (Estándar)",
    baselineSubscription_ENGINE: "Luckey Engine",
    baselineSubscription_undefined: "Usar suscripción personalizada",
    subscriptionData: "Información de la suscripción",
    noSubscriptionFound: "No se encontró ninguna suscripción todavía.",
    noSubscriptionFoundPleaseCheck: " Por favor, verifica los campos ",
    noSubscriptionFoundDescription: "La lista de suscripciones está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo",
    selectedSubscription: "Suscripción seleccionada: ",
    plantName: "Nombre del sistema",
    plantName_desc: "En minúsculas, sin espacios y, si es necesario, separado por guiones - ej. nombre-dominio-ejemplo",
    keyAccountManager: "Key Account Manager",
    keyAccountManager_desc: "Correo electrónico del Key Account Manager",
    systemManagerEmails: "Correo electrónico del Administrador del Sistema (uno o más)",
    systemManagerEmails_desc: "Correo electrónico de la persona encargada de gestionar los permisos de acceso de los usuarios en la plataforma web",
    installerEmail: "Correo del instalador (no obligatorio)",
    installerEmail_desc: "",
    pmEmail: "Correo del PM (no obligatorio)",
    pmEmail_desc: "Debe pertenecer a @sofialocks.com o @iseo.com",
    systemEngineerEmail: "Correo del Ingeniero de Sistemas (no obligatorio)",
    systemEngineerEmail_desc: "Debe pertenecer a @sofialocks.com o @iseo.com",
    numberOfElements: "Número de elementos a gestionar",
    numberOfElements_desc: "Los elementos son la suma de: usuarios, cerraduras y cualquier invitación activa",
    V364orF9000: "¿Cerraduras V364/1RIS o cilindros F9000?",
    V364orF9000_desc: "¿Existen cerraduras V364/1RIS o cilindros F9000 en el sistema? En ese caso, el complemento asociado se agregará automáticamente.",
    addons: "Complementos y Plug-ins",
    addons_desc: "Selecciona los complementos a agregar a la suscripción base",
    credits: "Número de créditos",
    credits_desc: "Créditos vendidos con esta activación del sistema",
    expectedEnd: "Según tu selección, se agotarán los créditos en: ",
    finalData: "Otra información",
    notes: "Notas",
    notes_desc: "Escribe aquí cualquier nota adicional relacionada con esta solicitud",
    notifications: "Notificaciones",
    notifications_desc: "Personas a notificar para eventos; por defecto, se notificará al propietario de la solicitud y al Key Account Manager asociado",
    editBaselineSubscriptionWarning: "¿Estás seguro de que deseas cambiar la suscripción base? Esto restablecerá los complementos seleccionados en el formulario.",
    editBaselineSubscriptionError: "Ocurrió un error, por favor, inténtalo de nuevo",
    editNumberOfElementsWarning: "¿Estás seguro de que deseas cambiar el número de elementos? Esto restablecerá los complementos disponibles en el formulario.",
    editNumberOfElementsError: "Ocurrió un error, por favor, inténtalo de nuevo",
    customerMarketplaceError: "El usuario final seleccionado no tiene ningún mercado asociado. Por favor, contacta a soporte para solucionar el problema.",
    customerClusterError: "El usuario final seleccionado no tiene ningún cluster asociado. Por favor, contacta a soporte para solucionar el problema.",
    invoiceData: "Factura",
    invoiceFile: "Factura PDF *",
    invoiceFile_desc: "Sube la factura en formato PDF.",
    invoiceFile_desc2: "Límite de archivos: 1  ~  Tamaño máximo de cada archivo: 10MB",
    invoiceNumber: "Número de factura de venta y fecha (XXXXXX - DD/MM/AAAA)",
    invoiceNumberPlaceholder: "XXXXXX - DD/MM/AAAA",
    setInvoiceData: "Subir factura",
    dataMissingCreated: "Especifica el número de factura y el PDF para continuar"
  },
  recharges: {
    recalculate: 'Recalcular',
    restartRechargeJob: 'Reiniciar cálculo',
    restartRechargeJobConfirm: '¿Estás seguro de querer reiniciar el cálculo de las recargas?',
    restartRechargeJobSuccess: 'Cálculo de recargas reiniciado correctamente',
    restartRechargeJobError: 'Ocurrió un error al reiniciar el cálculo de las recargas. Por favor, inténtalo de nuevo',
    addNewRechargeButton: "Agregar recarga de billetera",
    noRechargesFoundTitle: "No se encontraron recargas",
    noRechargesFoundDescription: "No hay recargas de billetera en el sistema. Crea nuevas para comenzar",
    customerAndWallet: "Usuario final y billetera",
    seeCustomer: "Información",
    seeCustomerDetails: "Ver detalles del usuario final",
    selloutOrder: "Orden de venta",
    intragroupOrder: "Orden intra-grupo",
    custref: "Ref. Cliente",
    mode: "Tipo de renovación de contrato:",
    creditsSuggested: "Créditos sugeridos",
    creditsConfirmed: "Créditos confirmados",
    rejectedReason: "Motivo de rechazo",
    deletedReason: "Motivo de eliminación",
    createdAt: "Creado el",
    updatedAt: "Actualizado el",
    customerSearch: "Buscar entre usuarios finales existentes",
    customerSearchEnterName: "Buscar por nombre...",
    customerSearchNoMatch: "No se encontraron usuarios finales...",
    varSearch: "Buscar entre los VAR existentes",
    varSearchEnterName: "Buscar por nombre...",
    varSearchNoMatch: "No se encontró ningún VAR...",
    varCustomerSearch: "Buscar entre los usuarios finales del VAR",
    plantSearch: "Selecciona el dominio deseado",
    plantSearchEnterName: "Selecciona dominio",
    plantSearchNoMatch: "No se encontró ningún dominio...",
    plantProceedWithSelected: "Usar dominio/billetera seleccionada",
    dataMissingTakenCharge: "Especifica los créditos confirmados y la orden de venta para continuar",
    dataMissingScratchcardCreated: "Especifica el número de factura y el PDF para continuar",
    changeStatusToSelloutOrderGenerated: "Enviar a revisión",
    changeStatusToInvoiced: "Enviar a facturado",
    changeStatusToCreated: "Enviar a creado",
    changeStatusToRejected: "Rechazar solicitud",
    changeStatusToScratchcardCreated: "Recarga creada",
    changeStatusToWalletRecharged: "Billetera recargada",
    changeStatusAdmin: "Establecer estado (admin)",
    createCard: "Crear tarjeta de recarga",
    changeCustRef: "Establecer Ref. Cliente",
    search: "Buscar...",
    resetFilters: "Restablecer filtros",
    statusSelection: "Cualquier estado",
    clusterSelection: "Cualquier cluster",
    statusTO_BE_MANAGED: "Por gestionar",
    statusTAKEN_CHARGE: "En proceso",
    statusREQUEST_TO_DELETE: "Solicitud de eliminación",
    statusSELLOUT_ORDER_GENERATED: "Bajo revisión",
    statusSCRATCHCARD_CREATED: "Recarga creada",
    statusWALLET_RECHARGED: "Recargada",
    statusREJECTED: "Rechazada",
    statusDELETED: "Eliminada",
    statusINVOICED: "Facturada",
    promote: "Eliminar",
    saveRequest: "Guardar solicitud",
    createRequest: "Crear recarga de billetera",
    takeCharge: "Tomar en cuenta",
    AUTO_RENEWABLE: "Renovable automáticamente",
    NOT_AUTO_RENEWABLE: "No renovable automáticamente",
    deleteRechargeConfirm: "¿Estás seguro de que deseas eliminar esta solicitud? Por favor, especifica el motivo. La operación no se puede deshacer",
    deleteAdminRechargeConfirm: "¿Estás seguro de que deseas eliminar permanentemente esta solicitud? La operación no se puede deshacer",
    deleteRechargeError: "Ocurrió un error al eliminar la solicitud. Por favor, inténtalo de nuevo",
    takechargeRechargeConfirm: "Por favor, especifica el tipo de renovación para continuar con esta solicitud",
    takechargeRechargeDirectConfirm: "¿Estás seguro de que deseas tomar en cuenta esta solicitud?",
    takechargeRechargeError: "Ocurrió un error al tomar en cuenta la solicitud. Por favor, inténtalo de nuevo",
    promoteRechargeConfirm: "¿Estás seguro de que deseas enviar esta solicitud a revisión? La solicitud no se puede editar mientras esté en revisión.",
    promoteRechargeError: "Ocurrió un error al promover la solicitud. Por favor, inténtalo de nuevo",
    createdRechargeConfirm: "¿Estás seguro de que deseas enviar esta solicitud al estado CREADO?",
    createdRechargeError: "Ocurrió un error al actualizar el estado de la solicitud. Por favor, inténtalo de nuevo",
    invoicedRechargeConfirm: "¿Estás seguro de que deseas marcar esta solicitud como facturada?",
    invoicedRechargeError: "Ocurrió un error al actualizar el estado de la solicitud. Por favor, inténtalo de nuevo",
    editStatusRechargeConfirm: "¿Estás seguro de que deseas editar el estado de esta solicitud? La operación no se puede deshacer",
    editStatusRechargeError: "Ocurrió un error al actualizar el estado de la solicitud. Por favor, inténtalo de nuevo",
    rejectRechargeConfirm: "Especifica el motivo para rechazar esta solicitud.",
    rejectRechargeError: "Ocurrió un error al rechazar la solicitud. Por favor, inténtalo de nuevo",
    scratchcardCreatedRechargeConfirm: "¿Estás seguro de que deseas aceptar esta solicitud y confirmar que la tarjeta de recarga ha sido creada?",
    scratchcardCreatedRechargeError: "Ocurrió un error al aceptar la solicitud. Por favor, inténtalo de nuevo",
    walletRechargedRechargeConfirm: "¿Estás seguro de que deseas marcar esta solicitud como completada y confirmar que la billetera ha sido recargada?",
    walletRechargedRechargeError: "Ocurrió un error al cambiar el estado de la solicitud. Por favor, inténtalo de nuevo",
    newFileName: "Especifica el nombre del archivo",
    newFileExtensionError: "El archivo tiene una extensión no soportada",
    newFileDuplicateNameError: "Este nombre ya ha sido utilizado para otro archivo. Cambia el nombre y repite la operación.",
    editCustrefConfirm: "Especifica la Ref. Cliente para esta solicitud.",
    editCustrefError: "Ocurrió un error al actualizar la Ref. Cliente, por favor, inténtalo de nuevo",
    editRecharge: "Editar recarga de billetera",
    newRecharge: "Agregar recarga de billetera",
    viewRecharge: "Ver recarga de billetera",
    newRechargeError: "Ocurrió un error al crear esta solicitud. Por favor, inténtalo de nuevo",
    editRechargeError: "Ocurrió un error al actualizar esta solicitud. Por favor, inténtalo de nuevo",
    exportRechargesCSV: "Exportar CSV",
    basicData: "Parámetros de recarga de billetera",
    ordersData: "Órdenes",
    invoiceData: "Factura",
    formEnterAnswer: "Tu respuesta",
    formEnterAnswerGT0: "Número mayor que cero",
    sfdcId: "ID de oportunidad (SFDC)",
    salesOrderConfirmationNumber: "Número de confirmación de orden de venta (venta)",
    salesOrderConfirmationNumber_desc: "",
    selloutFiles: "Orden de venta PDF (hardware + software + servicios profesionales)",
    selloutFiles_desc: "Necesario para rastrear correctamente los ingresos de Blossom.",
    selloutFiles_desc2: "Límite de archivos: 5  ~  Tamaño máximo de cada archivo: 10MB  ~  Extensiones permitidas: ",
    selloutFilesAdd: "Subir archivo",
    selloutFilesDownload: "Descargar",
    selloutFilesReplace: "Reemplazar",
    invoiceFile: "Factura PDF *",
    invoiceFile_desc: "Sube la factura en formato PDF.",
    invoiceFile_desc2: "Límite de archivos: 1  ~  Tamaño máximo de cada archivo: 10MB",
    invoiceNumber: "Número de factura de venta (para el usuario final) *",
    purchaseOrderNumberSofia: "Número de Orden de Compra a Sofia",
    orderContactEmail: "Correo de contacto de la orden"
  },
  vars: {
    varCategoryType: 'Tipo',
    varCategoryType_VAR: 'VAR',
    varCategoryType_DEALER: 'Dealer',
    vashoManual: 'Guía Partners',
    partnerLevel: 'Nivel de partner',
    runningQuotations: 'Cotizaciones en curso',
    activeCustomers: 'Clientes activos',
    activeSystems: 'Sistemas activos',
    monthlyCreditsBurnRate: 'Consumo mensual de créditos',
    varHome: 'Home',
    candidatePartnerStepsAway: 'Necesitas firmar el contrato para convertirte en partner registrado',
    candidatePartnerStepsAwayDescription: 'Firma e invia el acuerdo VAR para convertirte en partner registrado',
    registeredPartnerStepsAway: 'Estás a un paso de ser un partner registrado',
    registeredPartnerStepsAwayDescription: 'Firma e invia el acuerdo VAR para convertirte en partner registrado',
    preferredPartner: 'Eres clasificado como partner preferido!',
    preferredPartnerDescription: 'Estás ahora visible en nuestro sitio web como partner preferido',
    preferredPartnerStepsAway: 'Estás a {{steps}} pasos de ser un partner preferido',
    preferredPartnerStepsAwayDescription: 'Para ser visible en nuestro sitio web como partner preferido, debes completar los pasos restantes',
    partnerLevelContractSigned: 'Acuerdo firmado',
    partnerLevelRebateLetterSigned: 'Letra de rebate firmada',
    partnerLevelTrainingCompleted: 'Capacitación completada',
    partnerLevelDemoKitPurchased: 'Kit demo adquirido',
    partnerLevelQuotationRequested: 'Cotización solicitada',
    partnerLevelOneActiveCustomer: 'Un cliente activo',
    varDocumentHistoryRebateLetter: 'Historial de archivos',
    varDocumentHistoryAgreement: 'Historial de archivos',
    varDocumentHistoryDate: 'Fecha de sustitución',
    syncsfdcidVarOpportunitySuccess: 'Solicitud tomada en cuenta. Por favor, verifica la oportunidad correspondiente en Salesforce',
    varLogo: "Logo",
    setTrainingDate: "Establecer fecha de capacitación",
    missingLastTrainingDateForCertificate: "Este VAR no tiene una fecha de capacitación establecida. Por favor, establece una fecha de capacitación e intenta generar el certificado de nuevo",
    expiredLastTrainingDateForCertificate: 'La capacitación de este VAR ha expirado. Por favor, actualiza la fecha de capacitación y vuelve a intentarlo',
    varLastTrainingData: "Última fecha de capacitación",
    varShortDescription: "Descripción corta",
    varLastTrainingDataExpirationDate: "Fecha de caducidad de la capacitación",
    rebateLetterFile: 'Letra de rebate',
    varRebateLetterFileExpirationDate: 'Fecha de caducidad de la letra de rebate',
    varAgreementFileExpirationDate: 'Fecha de caducidad del acuerdo',
    varDemoKitPurchaseDate: 'Compra de kit de demostración',
    varDemoKitOrderNumber: 'Número de pedido de kit de demostración',
    varCity: "Ciudad",
    varCountry: "País",
    varWebsite: "Sitio web",
    varVisibleOnSofiaWebsite: "Visible en la página de socios de Sofia",
    downloadCertificate: "Descargar certificado",
    opportunityChangeOwnerMessage: "Por favor, especifica el propietario de esta cotización",
    noOpportunityHistoryFound: "No se encontró historial de cotizaciones",
    noOpportunityHistoryFoundDescription: "Esta cotización no tiene registros históricos",
    customers: "Clientes",
    varsManagement: "VARs",
    varSettings: "Configuraciones",
    varInfoPage: "Capacitación y Recursos",
    varUsersPage: "Usuarios",
    vars: "VAR",
    plantThemes: "Temas de dominio",
    editVarPersonalConfirm: "Estás a punto de editar la información de tu empresa. ¿Estás seguro de que deseas continuar?",
    editVarConfirm: "Estás a punto de editar los datos del VAR. ¿Estás seguro de que deseas continuar?",
    editVar: "Editar VAR",
    newVar: "Nuevo VAR",
    varCreationConfirm: "¿Deseas crear el nuevo VAR?",
    createVar: "Crear VAR",
    noVarFindTitle: "No se encontró ningún VAR",
    noVarFindDescription: "La lista de VAR está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo",
    noPlantThemeFindTitle: "No se encontró ningún tema de dominio",
    noPlantThemeFindDescription: "La lista de temas de dominio está vacía. Si has aplicado un filtro de búsqueda, intenta restablecerlo y vuelve a intentarlo",
    clusterSelection: "Cualquier cluster",
    varSelection: "Cualquier VAR",
    varName: "Nombre",
    varAddress: "Dirección",
    varEmail: "Correo de contacto principal",
    varPhone: "Teléfono",
    varCluster: "Cluster",
    varVat: "IVA",
    varTechContact: "Contacto técnico",
    varCommercialContact: "Contacto comercial",
    varNameTech: "Nombre del contacto técnico",
    varEmailTech: "Correo del contacto técnico",
    varPhoneTech: "Teléfono del contacto técnico",
    varNameComm: "Nombre del contacto comercial",
    varEmailComm: "Correo del contacto comercial",
    varPhoneComm: "Teléfono del contacto comercial",
    varSfdcid: "ID DE CUENTA SFDC",
    varSupportEmail: "Correo de soporte",
    varSupportHours: "Horario de atención de soporte",
    varCompanyName: "Nombre de la empresa",
    varCustomers: "Usuarios finales del VAR",
    varUsers: "Usuarios del VAR",
    varOpportunities: "Cotizaciones del VAR",
    editPlantThemeConfirm: "Estás a punto de editar los datos del tema del dominio. ¿Estás seguro de que deseas continuar?",
    editPlantTheme: "Editar tema de dominio",
    newPlantTheme: "Nuevo tema de dominio",
    plantThemeCreationConfirm: "¿Deseas crear el nuevo tema de dominio?",
    editVarPersonal: "Editar información de la empresa",
    plantThemeName: "Nombre",
    plantThemeColour: "Color *",
    plantThemeColourDescription: "Color del tema",
    plantThemeLogo: "Logo",
    plantThemeDefault: "Usar como tema predeterminado",
    logoFile: "Imagen del logo *",
    logoFile_desc: "Extensiones de archivo permitidas: ",
    logoFileAdd: "Subir archivo",
    logoFileDownload: "Descargar",
    logoFileReplace: "Reemplazar",
    deletePlantThemeConfirm: "¿Estás seguro de que deseas eliminar este tema de dominio? La operación no se puede deshacer",
    plantThemeSearchEnterName: "Selecciona el tema",
    plantThemeSearch: "Selecciona el tema deseado",
    domainThemeTitle: "Tema de dominio personalizado",
    domainThemeDescription: "Establece tu tema personalizado en este dominio",
    plantThemeModifySuccess: "Tema de dominio modificado y actualizado",
    cannotDeleteAssociatedTheme: "No se puede eliminar un tema que está asociado a un dominio.",
    plantThemeAssociatedPlants: "Dominios asociados a este tema",
    newVarUser: "Nuevo usuario VAR",
    varUserCreationConfirm: "¿Deseas crear el nuevo usuario VAR?",
    createVarUser: "Crear usuario VAR",
    varUserFormTitle: "Usuario VAR",
    createNewVarUser: "Crear nuevo usuario VAR",
    noVarUserFindTitle: "No se encontraron usuarios VAR",
    noVarUserFindDescription: "La lista de usuarios VAR está vacía",
    deleteVarUserConfirm: "¿Estás seguro de que deseas eliminar este usuario VAR? La operación no se puede deshacer",
    deleteVarOpportunityConfirm: "¿Estás seguro de que deseas eliminar esta cotización? La operación no se puede deshacer",
    rejectVarOpportunityConfirm: "¿Estás seguro de que deseas rechazar esta cotización? La operación no se puede deshacer",
    approveVarOpportunityConfirm: "¿Estás seguro de que deseas aprobar esta cotización? La operación no se puede deshacer",
    syncsfdcidVarOpportunityConfirm: "¿Estás seguro de que deseas asociar un ID SFDC a esta cotización? La operación no se puede deshacer",
    upgradeVarOpportunityConfirm: "¿Estás seguro de que deseas enviar esta cotización a revisión? La operación no se puede deshacer",
    winVarOpportunityConfirm: "¿Estás seguro de que deseas marcar esta cotización como GANADA? La operación no se puede deshacer",
    lostVarOpportunityConfirm: "¿Estás seguro de que deseas marcar esta cotización como PERDIDA? La operación no se puede deshacer",
    deleteUserConfirm: "¿Estás seguro de que deseas eliminar este usuario? La operación no se puede deshacer",
    varUserUsername: "Nombre de usuario",
    varUserFirstname: "Nombre",
    varUserLastname: "Apellido",
    varUserEmail: "Correo electrónico",
    varUsersList: "Usuarios",
    newFileExtensionError: "El archivo tiene una extensión no soportada",
    agreementFile: "Acuerdo",
    opportunities: "Cotizaciones",
    opportunityManagement: "Información de la cotización",
    opportunityID: "ID",
    opportunityOpty: "ID OPTY de SFDC",
    opportunityVar: "VAR",
    opportunityCustomer: "Usuario final",
    opportunityOwner: "Propietario de la cotización",
    opportunityName: "Nombre de la cotización",
    opportunityValue: "Valor",
    opportunityStatus: "Estado",
    opportunityActions: "Acciones",
    opportunityDescription: "Descripción",
    opportunityNotes: "Notas",
    opportunityCrm: "CRM",
    noOpportunityFindTitle: "No se encontraron cotizaciones",
    noOpportunityFindDescription: "La lista de cotizaciones está vacía",
    opportunityStatus_DRAFT: "Borrador",
    opportunityStatus_ON_APPROVAL: "Bajo revisión",
    opportunityStatus_APPROVED: "Aprobada",
    opportunityStatus_CANCELLED: "Cancelada",
    opportunityStatus_REJECTED: "Rechazada",
    opportunityStatus_WON: "Ganada",
    opportunityStatus_LOST: "Perdida",
    opportunityFiles: "Archivos adjuntos",
    newOpportunity: "Nueva cotización",
    editOpportunity: "Editar cotización",
    opportunitySyncSFDC: "Sincronizar con SFDC",
    exportOpportunities: "Exportar CSV",
    upgradeOpportunity: "Enviar a revisión",
    approveOpportunity: "Aprobar",
    rejectOpportunity: "Rechazar",
    wonOpportunity: "Marcar como GANADA",
    lostOpportunity: "Marcar como PERDIDA",
    CREATED: "Cotización creada",
    VAR_USER_UPDATED: "Usuario VAR asignado a la cotización actualizado",
    DESCRIPTION_UPDATED: "Descripción de la cotización actualizada",
    NAME_UPDATED: "Nombre de la cotización actualizado",
    VALUE_UPDATED: "Valor de la cotización actualizado",
    CURRENCY_UPDATED: "Moneda de la cotización actualizada",
    OPTY_ID_UPDATED: "ID Opty de la cotización actualizado",
    ISEO_CRM_ID_UPDATED: "ID SFDC de la cotización actualizado",
    DOCUMENTS_UPDATED: "Documentos de la cotización actualizados",
    STATUS_ON_APPROVAL: "Cotización enviada a revisión",
    STATUS_APPROVED: "Cotización aprobada",
    STATUS_WON: "Cotización marcada como ganada",
    STATUS_LOST: "Cotización marcada como perdida",
    STATUS_DRAFT: "Cotización marcada como borrador",
    STATUS_CANCELLED: "Cotización marcada como cancelada",
    CANCELLED: "Cotización cancelada",
    STATUS_REJECTED: "Cotización marcada como rechazada",
    showOpportunityHistory: "Mostrar historial",
    opportunityHistory: "Historial de cotización"
  },
  save: "Guardar",
  languages: {
    it: "Italiano",
    en: "Inglés",
    de: "Alemán",
    fr: "Francés",
    es: "Español",
    nl: "Holandés",
    ITALIAN: "Italiano",
    ENGLISH: "Inglés",
    GERMAN: "Alemán",
    FRENCH: "Francés",
    SPANISH: "Español",
    DUTCH: "Holandés",
    menuHeading: "Elige un idioma"
  },
  productInfo: {
    software: "Software",
    salesMaterial: "Material de ventas",
    hardware: "Hardware",
    marketingMaterial: "Material de marketing"
  },
  users: {
    usersManagement: "Gestión de usuarios",
    users: "Usuarios",
    noUserFindTitle: "No se encontraron usuarios",
    noUserFindDescription: "La lista de usuarios está vacía. Intenta restablecer tus filtros de búsqueda si hay alguno",
    search: "Buscar...",
    roleSelection: "Rol",
    clusterSelection: "Cluster",
    varSelection: "VAR",
    newUser: "Agregar",
    userFirstname: "Nombre",
    userLastname: "Apellido",
    userEmail: "Correo electrónico",
    userFormTitle: "Datos del usuario",
    editUserForm: "Editar usuario",
    newUserForm: "Crear usuario"
  },
  permissions: {
    CSV_IMPORT: 'Gestión de importaciones de sistemas Master Key',
    CREATE_REQUEST: 'Crear solicitudes',
    MANAGE_REQUEST: 'Gestión de solicitudes',
    EXPORT_REQUESTS: 'Exportar solicitudes',
    MKS: 'Gestión de sistemas Master Key',
    SEARCH_BY_DOMAIN: 'Buscar por dominio',
    SELLOUT_GENERATED: 'Sellout generado',
    INVOICED: 'Facturado',
    MARK_UNDER_REVIEW: 'Marcar entidad como In revisión',
    NAVIGATION: "Visibilidad del menú",
    CLUSTER: "Cluster",
    VAR: "VAR",
    CUSTOMER: "Usuarios finales",
    OPPORTUNITY: "Cotizaciones",
    WALLET: "Billeteras de usuarios finales",
    DOMAIN: "Sistemas de usuarios finales",
    GATEWAYS: "Gateway",
    CARD: "Tarjetas de recarga",
    PLANT_ACTIVATION: "Activaciones del sistema",
    RECHARGE_REQUEST: "Recargas del sistema",
    ACTIVATION_REQUEST: "Solicitudes de activación",
    EXPORT: "Exportar entidades",
    CREATE: "Crear nueva entidad",
    UPDATE: "Actualizar una entidad",
    MARK_LOST: "Marcar entidad como Perdida",
    MARK_WON: "Marcar entidad como Ganada",
    CANCEL: "Marcar entidad como Cancelada",
    CANCEL_DRAFT: "Marcar entidad como Cancelada cuando es borrador",
    CANCEL_ON_APPROVAL: "Marcar entidad como Cancelada cuando está en revisión",
    CANCEL_APPROVED: "Marcar entidad como Cancelada cuando está aprobada",
    MARK_TO_BE_APPROVED: "Marcar entidad para Aprobación",
    RECHARGE: "Recargar",
    SUBSCRIPTION_UPDATE: "Actualizar suscripciones",
    DELETE_REQUEST: "Enviar solicitud de eliminación",
    CREATION_REQUEST: "Enviar solicitud para crear nueva entidad",
    MANAGER_CREATE: "Crear administradores",
    MANAGER_UPDATE: "Actualizar administradores",
    INSTALLER_CREATE: "Crear instaladores",
    INSTALLER_UPDATE: "Actualizar instaladores",
    IMPERSONATE_WRITE: "Personificar administradores",
    IMPERSONATE_SUPPORT: "Personificar cuenta de soporte",
    ADDITIONAL_INFO_UPDATE: "Editar información adicional",
    CUSTOMERS: "Usuarios finales",
    PLANT_ACTIVATIONS: "Activaciones del sistema",
    RECHARGE_REQUESTS: "Recargas del sistema",
    ACTIVATION_REQUESTS: "Solicitudes de activación",
    CARDS: "Tarjetas de recarga",
    VAR_USERS: "Usuarios VAR",
    VAR_SETTINGS: "Configuraciones VAR",
    OPPORTUNITIES: "Cotizaciones",
    PRODUCTINFO: "Información de producto",
    USER_READ: "Ver usuarios",
    USER_UPDATE: "Actualizar un usuario",
    USER_CREATE: "Crear nuevo usuario",
    PLANT_THEME: "Cambiar tema del dominio",
    READ: "Leer valores de entidad",
    ORDERS_STATUS: "Estado de las órdenes",
    FILTER: "Filtrar entidades",
    VAR_MANAGEMENT: "Gestión de VAR",
    MARKETPLACES: "Mercados",
    DOMAINS: "Sistemas de usuarios finales",
    PRICELIST: "Lista de precios",
    SALESINFO: "Información de ventas",
    PLATFORM_USERS: "Gestión de usuarios",
    APPROVE: "Marcar entidad como Aprobada",
    REJECT: "Marcar entidad como Rechazada",
    EXTEND: "Extender",
    CONFIG: "Leer configuraciones de entidad",
    IRIS_ENABLE: "Habilitar 1RIS para el dominio",
    MARK_TO_PROMOTE: "Marcar entidad para Promoción",
    MARK_TO_INVOCE: "Marcar entidad para Facturación",
    DELETE: "Eliminar entidades",
    EDIT: "Editar entidades",
    SUBSCRIPTION_DELETE: "Eliminar suscripciones",
    VAR_HOMEPAGE: 'Página VAR',
    CHANGE_OWNER: 'Cambiar propietario',
    CONTRACTS: 'Contratos',
    CONTRACT_SERVICES: 'Servicios de contrato',
    DOWNLOAD_CERTIFICATE: 'Descargar certificado',
    PLANTS_READ: 'Leer sistemas',
    PLANTS_UPDATE: 'Actualizar sistemas',
    PLANTS_CREATE: 'Crear sistemas',
    PLANTS_DELETE: 'Eliminar sistemas',
    SYNC_SFDCID: 'Sincronizar con SFDC',
    UPDATE_ADMIN: 'Actualizar administrador',
    HISTORY_READ: 'Leer historial',
    UPDATE_LOGO: 'Actualizar logo',
    EXPORT_ALL_MANAGERS: 'Exportar todos los administradores',
    LEGACY_DOMAINS_READ: 'Leer dominios legacy',
    TAKE_CHARGE: 'Tomar en carco',
    EDIT_ADMIN: 'Editar administrador',
    DEMO_READ: 'Leer sistemas demo',
    DEMO_CREATE: 'Crear sistemas demo',
    DEMO_UPDATE: 'Actualizar sistemas demo',
    DEMO_DELETE: 'Eliminar sistemas demo',
    DEMO_MANAGEMENT: 'Gestión de sistemas demo',
  },
  segmentTypes: {
    WORKING_SPACES_name: "Espacio de trabajo flexible",
    LIVING_name: "Vivienda flexible",
    RETAIL_name: "Venta al por menor flexible",
    UNIVERSITIES_name: "Universidades",
    LEISURE_name: "Ocio y hospitalidad",
    HOSPITAL_name: "Hospital",
    WORKING_SPACES_description: "Oficinas, coworking, centros de negocios",
    LIVING_description: "Residencial, cohousing, coliving, alojamiento estudiantil",
    RETAIL_description: "Retail multisucursal, centros comerciales, cadenas de tiendas",
    LEISURE_description: "Hoteles pequeños y medianos, alojamiento, centros deportivos",
    HOSPITAL_description: "Hospitales, residencias de ancianos y cuidado de adultos mayores",
    deprecated: 'OLD',
    ESTATE_WORKPLACES_REAAS_name: 'Estate - Workplaces - ReaaS [Coworking, Proworking, Business Centers]',
    ESTATE_WORKPLACES_BTR_name: 'Estate - Workplaces - BTR [Single company offices, Hybrid Workplaces, Multi-tenant office buildings, Business Parks]',
    ESTATE_RESIDENTIAL_REAAS_name: 'Estate - Residential - ReaaS [Coliving, Student housing (PBSA), Senior Housing]',
    ESTATE_RESIDENTIAL_BTR_name: 'Estate - Residential - BTR [Multifamily housing, Condos]',
    ESTATE_RESIDENTIAL_BTS_name: 'Estate - Residential - BTS [Multifamily housing, Condos, Cohousing]',
    ESTATE_EDUCATION_name: 'Estate - Education [Schools, Universities]',
    ESTATE_SPORT_FACILITIES_name: 'Estate - Sport Facilities [Arenas, Football stadiums, Tennis courts]',
    ESTATE_MUNICIPALITIES_name: 'Estate - Municipalities [Townhalls, Public Offices]',
    ESTATE_HEALTHCARE_name: 'Estate - Healthcare [Hospitals, Elderly care facilities]',
    ESTATE_RETAIL_MULTI_SITE_name: 'Estate - Retail - Multi site [Pharmacies, Postal Offices, Banks, DIY stores, Fashion, Private clinics]',
    ESTATE_HOSPITALITY_PROFESSIONAL_name: 'Estate - Hospitality - Professional [Big hotels]',
    ESTATE_HOSPITALITY_SMALL_name: 'Estate - Hospitality - Small [Small Hotels, B&Bs, Camping sites]',
    UTILITIES_TELECOM_name: 'Utilities - Telecom [Infrastructure, Operartors]',
    UTILITIES_ELECTRICITY_name: 'Utilities - Electricity [Production, Distribution]',
    'UTILITIES_OIL&GAS_name': 'Utilities - Oil&Gas [Pipes, Transportation]',
    UTILITIES_WATER_name: 'Utilities - Water [Purification, Distribution, Wastewater treatment]',
    UTILITIES_WASTE_name: 'Utilities - Waste [Bio Hazard]',
    UTILITIES_TRANSPORTATION_name: 'Utilities - Transportation [Railways, Subway, Roads, Airports]',
    DEMO_name: 'Demo',
  },
  demoSystem: {
    title: 'Mis sistemas demo',
    name: 'Nombre',
    notes: 'Notas',
    url: 'URL',
    peopleUsing: 'Personas que utilizan este demo',
    openNow: 'Abrir ahora',
    noDataTitle: 'No se encontraron sistemas demo',
    noDataDescription: 'No hay sistemas demo disponibles en este momento',
    newDemoPlantAssociation: 'Asignar sistema demo',
    demoPlantAssociationCompleted: 'Sistema demo asignado con éxito',
    createDemoPlantAssociationError: 'Ocurrió un error al asignar el sistema demo. Por favor, inténtalo de nuevo',
    deleteDemoPlantAssociation: '¿Estás seguro de querer eliminar esta asociación de sistema demo?',
    deleteDemoPlantAssociationConfirm: 'Asociación de sistema demo eliminada con éxito',
    deleteDemoPlantAssociationError: 'Ocurrió un error al eliminar la asociación de sistema demo. Por favor, inténtalo de nuevo',
    demoPlantAssociationEditedCompleted: 'Asociación de sistema demo editada con éxito',
    editDemoPlantAssociationError: 'Ocurrió un error al editar la asociación de sistema demo. Por favor, inténtalo de nuevo',
    demoSystemsTitle: 'Sistemas demo',
  },
  agreements: {
    privacyPolicy: 'Política de Privacidad',
    termsAndConditions: 'Términos y Condiciones',
    acceptAgreements: 'Aceptar',
    agreementsUpdated: 'Acuerdos Actualizados',
    pleaseAcceptAgreements: 'Por favor acepte los acuerdos actualizados para continuar',
    errorAcceptTermsAndPrivacy: 'Error al aceptar los términos y la política de privacidad',
  },
  mks: {
    yourRoleDoesNotHavePermissionToImportCsv: 'Tu rol no tiene permiso para importar archivos CSV MKS. Por favor, verifica tus permisos y vuelve a intentarlo.',
    status_COMPLETED: 'Anterior',
    status_CURRENT: 'Actual',
    status_ERROR: 'Error',
    requestType: 'Tipo de Solicitud',
    selectFileFormat: 'Seleccionar formato de archivo',
    importFileFormat_LOCKBASE: 'Lockbase',
    importFileFormat_SUPERLOCK: 'Superlock',
    importFileFormat: 'Formato de Importación',
    mksTitle: 'Master Key Systems',
    cylindersTitle: 'Cilindros',
    keysTitle: 'Llaves',
    keyDetails: 'Detalles de la llave',
    cylinderDetails: 'Detalles del cilindro',
    hostnameRequiredForImportDescription: 'Por favor, introduce un nombre de host de dominio para importar los datos',
    id: 'ID',
    externalId: 'ID Externo',
    doorName: 'Nombre de Puerta',
    marking: 'Marcado',
    type: 'Tipo',
    insideLength: 'Longitud Interior',
    outsideLength: 'Longitud Exterior',
    quantity: 'Cantidad',
    quantityKeys: 'Cantidad de Llaves',
    keyFunction: 'Función de Llave',
    designation: 'Designación',
    companyId: 'ID de Empresa',
    hostnameRequired: 'Nombre del sistema (obligatorio)', 
    hostnameRequiredTitle: 'Sistema Requerido',
    hostnameRequiredDescription: 'Por favor, introduce el nombre de un sistema para ver la lista',
    noCylindersFoundTitle: 'No se Encontraron Cilindros',
    noCylindersFoundDescription: 'No se encontraron cilindros para el sistema especificado',
    noKeysFoundTitle: 'No se Encontraron Llaves',
    noKeysFoundDescription: 'No se encontraron llaves para el sistema especificado',
    filterByType: 'Tipo de Cilindro',
    filterByDoorName: 'Nombre de Puerta',
    filterByKeyFunction: 'Función de Llave',
    filterByDesignation: 'Designación de Llave',
    importsTitle: 'Importaciones',
    noImportsFoundTitle: 'No se Encontraron Importaciones',
    noImportsFoundDescription: 'No se encontraron importaciones para el sistema especificado',
    filterByStatus: 'Estado de Importación',
    filterByFilename: 'Nombre de Archivo',
    uploadCsv: 'Subir archivo',
    uploadCsvTitle: 'Subir Archivo',
    dragDropCsv: 'Arrastra y suelta tu archivo aquí',
    orClickToSelect: 'o haz clic para seleccionar un archivo',
    previewCsv: 'Vista Previa de archivo',
    csvPreviewTitle: 'Vista Previa de Importación',
    previewSummary: 'Resumen de Importación',
    csvHasErrors: 'El archivo contiene errores de validación. Solo se importarán las filas válidas.',
    validationErrors: 'Errores de Validación',
    dataPreview: 'Vista Previa de Datos',
    noValidRowsToImport: 'No se encontraron filas válidas para importar. Por favor, corrige los errores e inténtalo de nuevo.',
    confirmImport: 'Confirmar Importación',
    fileInfo: 'Información del Archivo',
    importSummary: 'Resumen de Importación',
    filename: 'Nombre de Archivo',
    importTimestamp: 'Fecha de Importación',
    status: 'Estado',
    keysImported: 'Llaves Importadas',
    cylindersImported: 'Cilindros Importados',
    relationsImported: 'Relaciones Importadas',
    errorsCount: 'Conteo de Errores',
    userEmail: 'Email de Usuario',
    noKeySelected: 'Ninguna llave seleccionada',
    noCylinderSelected: 'Ningún cilindro seleccionado',
    customAttributes: 'Atributos Personalizados',
    associatedCylinders: 'Cilindros Asociados',
    associatedKeys: 'Llaves Asociadas',
    noAssociatedCylinders: 'No se encontraron cilindros asociados',
    noAssociatedKeys: 'No se encontraron llaves asociadas',
    relationId: 'ID de Relación',
    fileSize: 'Tamaño de Archivo',
    totalRows: 'Filas Totales',
    errors: 'Errores',
    keys: 'Llaves',
    cylinders: 'Cilindros',
    relations: 'Relaciones',
    currentConfig: 'Configuración Actual',
    confirmImportTitle: 'Confirmar Importación',
    confirmImportMessage: '¿Está seguro de que desea importar este archivo?',
    fileName: 'Nombre del Archivo',
    warningMessage: 'ADVERTENCIA: Esta operación sobrescribirá completamente la configuración actual del sistema con los datos de este archivo. Esta operación es irreversible.',
    comparisonTitle: 'Comparación con la Configuración Actual',
    currentLabel: 'Actual',
    newLabel: 'Nueva',
    requestsTitle: 'Solicitudes MKS',
    newRequest: 'Nueva Solicitud',
    editRequest: 'Editar Solicitud',
    requestManagement: 'Gestión de Solicitudes',
    requestType_KEY_DUPLICATION: 'Duplicación de Llave',
    requestType_CYLINDER_DUPLICATION: 'Duplicación de Cilindro',
    requestType_KEY_EXTENSION: 'Extensión de Llave',
    requestType_CYLINDER_EXTENSION: 'Extensión de Cilindro',
    requestStatus: 'Estado',
    requestStatus_DRAFT: 'Borrador',
    requestStatus_SENT: 'Enviada',
    requestStatus_TAKEN_IN_CHARGE: 'Tomada en Cargo',
    requestStatus_REJECTED: 'Rechazada',
    requestStatus_CANCELED: 'Cancelada',
    requestStatus_ORDER_CONFIRMED: 'Pedido Confirmado',
    requestStatus_ORDER_SHIPPED: 'Pedido Enviado',
    requestStatus_ORDER_COMPLETED: 'Pedido Completado',
    historyAction_CREATED: 'Creada',
    historyAction_UPDATED: 'Actualizada',
    historyAction_STATUS_CHANGED: 'Estado Cambiado',
    historyAction_STATUS_DRAFT: 'Estado Borrador',
    historyAction_STATUS_SENT: 'Estado Enviada',
    historyAction_STATUS_TAKEN_IN_CHARGE: 'Estado Tomada en Cargo',
    historyAction_STATUS_REJECTED: 'Estado Rechazada',
    historyAction_STATUS_ORDER_CONFIRMED: 'Estado Pedido Confirmado',
    historyAction_STATUS_ORDER_SHIPPED: 'Estado Pedido Enviado',
    historyAction_STATUS_ORDER_COMPLETED: 'Estado Pedido Completado',
    historyAction_STATUS_CANCELED: 'Estado Cancelada',
    historyAction_NOTES_UPDATED: 'Notas Actualizadas',
    historyAction_DELIVERY_DATE_UPDATED: 'Fecha de Entrega Actualizada',
    historyAction_DOCUMENTS_ADDED: 'Documentos Agregados',
    historyAction_DOCUMENTS_REMOVED: 'Documentos Eliminados',
    historyAction_CANCELLED: 'Cancelada',
    historyAction_COMPLETED: 'Completada',
    requestNotes: 'Notas',
    requestData: 'Datos de Solicitud (JSON)',
    plantHostname: 'Hostname de Planta',
    companyName: 'Empresa',
    createdBy: 'Creado Por',
    deliveryDate: 'Fecha de Entrega',
    plantSearch: 'Buscar Sistema',
    plantSearchNoMatch: 'No se encontraron sistemas',
    plantSearchEnterName: 'Ingrese hostname para buscar',
    selectRequestType: 'Seleccionar Tipo de Solicitud',
    requestTypeFilter: 'Filtrar por Tipo',
    statusFilter: 'Filtrar por Estado',
    sendRequest: 'Enviar Solicitud',
    takeInCharge: 'Tomar en Cargo',
    rejectRequest: 'Rechazar',
    confirmOrder: 'Confirmar Pedido',
    shipOrder: 'Enviar Pedido',
    completeOrder: 'Completar Pedido',
    deleteMKSRequestConfirm: '¿Está seguro de que desea cancelar esta solicitud?',
    changeStatusMKSRequestConfirm: '¿Está seguro de que desea cambiar el estado de esta solicitud?',
    requestHistory: 'Historial de Solicitud',
    noRequestHistoryFound: 'No se Encontró Historial',
    noRequestHistoryFoundDescription: 'No se encontraron registros de historial para esta solicitud',
    noRequestFindTitle: 'No se Encontraron Solicitudes',
    noRequestFindDescription: 'No se encontraron solicitudes MKS. Intente ajustar sus filtros de búsqueda.',
    exportRequests: 'Exportar Solicitudes',
    createMKSRequestConfirm: '¿Está seguro de que desea crear esta nueva solicitud MKS?',
    editMKSRequestConfirm: '¿Está seguro de que desea editar esta solicitud MKS?',
    openMKSRequestsError: 'Ocurrió un error al cargar las solicitudes MKS. Por favor, inténtelo de nuevo',
    createMKSRequestError: 'Ocurrió un error al crear la solicitud. Por favor, inténtelo de nuevo',
    editMKSRequestError: 'Ocurrió un error al actualizar la solicitud. Por favor, inténtelo de nuevo',
    deleteMKSRequestError: 'Ocurrió un error al cancelar la solicitud. Por favor, inténtelo de nuevo',
    changeMKSRequestStatusError: 'Ocurrió un error al cambiar el estado de la solicitud. Por favor, inténtelo de nuevo',
    seePlant: 'Ver sistema',
    customerName: 'Nombre del Cliente',
    varName: 'Nombre VAR',
    length: 'Longitud',
    cylindersList: 'Lista de Cilindros',
    cylindersData: 'Datos de Cilindros (JSON)',
    keysList: 'Lista de Llaves',
    keysData: 'Datos de Llaves (JSON)',
    assignedUser: 'Usuario Asignado',
    selectAssignedUser: 'Seleccionar Usuario Asignado',
    selectCylinders: 'Seleccionar Cilindros',
    selectKeys: 'Seleccionar Llaves',
    requestFiles: 'Archivos de Solicitud',
    rejectedNotes: 'Notas de Rechazo',
    setDeliveryDateConfirm: 'Establece la fecha de entrega para este pedido',
    editDeliveryDate: 'Editar Fecha de Entrega',
    editDeliveryDateConfirm: 'Actualiza la fecha de entrega para este pedido',
    saveRequestConfirmation: 'Guardar Solicitud',
    saveRequestConfirmationMessage: '¿Desea guardar la solicitud como borrador o enviarla ahora?',
    saveRequestConfirmationConfirm: 'Enviar Ahora',
    saveRequestConfirmationCancel: 'Guardar como Borrador',
    createDuplicateKeyRequest: 'Crear Solicitud de Duplicación de Llave',
    createDuplicateCylinderRequest: 'Crear Solicitud de Duplicación de Cilindro',
    selectCylinder: 'Seleccionar Cilindro',
    selectKey: 'Seleccionar Llave',
    relationsMatrixTitle: 'Matriz de Relaciones',
    cylinderName: 'Nombre del Cilindro',
    noRelationsFoundTitle: 'No se Encontraron Relaciones',
    noRelationsFoundDescription: 'No se encontraron relaciones cilindro-llave para el sistema especificado',
    selectedKey: 'Llave Seleccionada',
    selectedCylinder: 'Cilindro Seleccionado',
    selectedKeys: 'Llaves Seleccionadas',
    plantSearchPlaceholder: 'Buscar un sistema',
    keysDuplicates: 'Duplicados de Llaves',
    cylindersDuplicates: 'Duplicados de Cilindros',
    addKey: 'Agregar Llave',
    addCylinder: 'Agregar Cilindro',
    duplicateEntry: 'Entrada Duplicada',
    duplicateKey: 'Llave Duplicada',
    duplicateCylinder: 'Cilindro Duplicado',
    noKeysSelected: 'No hay llaves seleccionadas',
    noCylindersSelected: 'No hay cilindros seleccionados',
    quantityError: 'La cantidad debe ser un entero mayor que cero',
    batchAdd: 'Agregar en Lote',
    batchAddTitleCylinders: 'Agregar Cilindros en Lote',
    batchAddTitleKeys: 'Agregar Llaves en Lote',
    batchAddFilterCylinders: 'Filtrar cilindros',
    batchAddFilterKeys: 'Filtrar llaves',
    batchAddConfirm: 'Confirmar',
    batchAddCancel: 'Cancelar',
    batchAddNoResults: 'No se encontraron elementos',
    batchAddTooManyResults: 'Demasiados resultados (más de {{limit}}). Por favor refine su filtro de búsqueda.',
    alreadySelected: 'Ya seleccionado',
    openAdvancedSelector: 'Abrir Selector Avanzado',
    selectCylindersWithCount: 'Seleccionar Cilindros ({{count}})',
    selectKeysWithCount: 'Seleccionar Llaves ({{count}})',
    selectedItemsCount: '{{count}} elementos seleccionados',
    itemsWillBeAdded: '{{count}} elementos serán agregados',
    addItems: 'Agregar Elementos ({{count}})',
    generatePdf: 'Generar PDF',
    requestPdf: 'PDF de Solicitud',
    pdfGenerationError: 'Se produjo un error al generar el PDF. Por favor, inténtelo de nuevo',
    generateXlsx: 'Generar Excel',
    xlsxGenerationError: 'Se produjo un error al generar el archivo Excel. Por favor, inténtelo de nuevo',
    generateDocx: 'Generar Word',
    docxGenerationError: 'Se produjo un error al generar el documento Word. Por favor, inténtelo de nuevo',
    exportRequest: 'Exportar Solicitud',
    field: 'Campo',
    value: 'Valor',
  },
  developers: {
    integrationInfo: 'Información de integración',
    api: 'API',
    sdk: 'SDK',
    knx: 'KNX',
    developersResource: 'Recursos de desarrolladores',
  },
  iseo: {
    trainingMaterials: 'Materiales de formación ISEO',
  },
  iseoSalesApps: {
    launchpadMissingToken: 'No se pudo leer el token de sesión de Vasho. Inicie sesión de nuevo y abra Sales Apps desde el menú.',
    missingBaseUrl: 'La URL base de Sales Apps no está configurada. Configúrela en Vasho Settings.',
  },
  settings: {
    title: 'Configuración',
    salesAppVersion: 'Versión de Sales Apps',
    salesAppVersionDescription: 'URL base del help-center (p. ej. …/sales-apps/v122) o launchpad (p. ej. …/launchpad).',
    save: 'Guardar',
    saveSuccess: 'Configuración guardada con éxito',
    saveError: 'No se pudo guardar la configuración. Por favor, inténtelo de nuevo',
    invalidValue: 'Por favor, ingrese un valor válido',
  },
};

export default translations;